<template>
  <div id="game" v-bind:class="{ subdueColors: this.subdueColors, compressedLayout: this.compressedLayout }">

    <modal
    name="results"
    width="355"
    height="auto"
    :scrollable="true"
    @before-open="beforeModalOpen"
    @before-close="beforeModalClose">
      <div id="resultsModal" class="modalContent">
        <div class="closeButton" @click="closeModal()"></div>

        <div class="inner">
          <div id="modalLogo">

            <svg v-if="this.userData.results.won" width="358" height="79" viewBox="0 0 358 79" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M174.884 7.11466C170.734 7.83193 167.352 10.9674 166.311 15.0604C166.21 15.4584 166.067 16.2845 165.995 16.8963L165.863 18.0088L166.614 19.5557C167.028 20.4065 167.503 21.6018 167.671 22.2121C168.307 24.5239 168.316 24.106 167.222 42.0508L166.223 58.441L166.549 58.7275C167.188 59.2912 168.558 60.0299 169.665 60.4081C170.719 60.7683 171.847 60.9138 187.378 62.6936C196.501 63.739 204.31 64.5924 204.731 64.59C207.038 64.5767 209.477 63.6357 211.372 62.0268L212.18 61.3406L212.135 60.4668C212.074 59.2963 213.552 26.5661 213.723 25.2929C214.094 22.5356 215.379 19.6891 217.123 17.7588L217.778 17.0345L217.384 16.3137C215.883 13.5651 213.62 11.738 210.754 10.9608C209.852 10.7161 177.34 6.9807 176.28 7.00008C175.829 7.00818 175.201 7.05984 174.884 7.11466ZM100.191 9.23152C99.6191 9.29128 67.5033 14.9394 67.295 15.0169C67.2081 15.0492 67.3847 15.5461 67.7623 16.3319C68.6589 18.1974 68.9972 19.6629 69.0683 21.9889C69.1321 24.0785 68.1962 54.2344 68.0014 56.3645C67.8427 58.1005 67.4 59.6475 66.5702 61.3658L65.8977 62.7585L66.2953 63.4464C66.514 63.8247 67.1379 64.5968 67.6818 65.162C69.2472 66.7889 71.0664 67.8023 73.1619 68.2144C75.1221 68.6 75.1609 68.5947 92.512 65.5398C101.425 63.9706 109.023 62.5984 109.397 62.4902C114.02 61.1536 117.279 56.5344 117.025 51.6798C116.945 50.1553 111.487 17.7022 111.126 16.6028C110.039 13.2981 107.367 10.6422 104.139 9.65871C103.308 9.40523 101.447 9.11516 100.933 9.15884C100.796 9.17062 100.462 9.20328 100.191 9.23152ZM292.634 10.1469C281.305 10.5822 276.403 10.8143 275.699 10.9483C272.436 11.5699 269.619 13.7488 268.122 16.8092L267.745 17.5803L268.676 18.5185C269.907 19.7592 270.675 20.805 271.375 22.1939C272.476 24.3773 272.919 26.2501 272.919 28.7183C272.919 29.8905 271.702 58.0346 271.52 61.0884L271.468 61.9505L272.193 62.5513C273.258 63.4339 274.717 64.1812 276.097 64.55C277.704 64.98 277.581 64.9816 296.156 64.285C307.786 63.8489 311.785 63.6593 312.531 63.5083C316.995 62.6049 320.425 58.8602 320.989 54.2754C321.125 53.1713 319.969 19.742 319.752 18.507C319.399 16.4945 318.427 14.5155 317.067 13.0389C315.094 10.8956 312.649 9.73949 309.786 9.59515C309.122 9.56173 301.403 9.81002 292.634 10.1469ZM22.1781 10.6588C17.2338 11.352 13.3799 15.5949 13.0431 20.7159C12.9323 22.3989 12 51.7146 12 53.5131C12 54.429 12.0603 55.5125 12.134 55.9209C12.9064 60.2009 16.2759 63.6736 20.4819 64.5239C21.8765 64.8057 54.3317 65.9216 55.6529 65.7331C60.047 65.1058 63.6518 61.7033 64.5889 57.2983C64.867 55.991 65.9746 22.6894 65.7913 21.1441C65.6288 19.7738 65.0911 18.1536 64.4079 16.9753C63.4678 15.3544 61.6383 13.6082 59.9947 12.7628C59.21 12.3591 57.5379 11.8566 56.6196 11.7483C56.2457 11.7043 49.2654 11.4432 41.1078 11.1681C32.9502 10.8931 25.5249 10.642 24.6072 10.6101C23.6895 10.5783 22.5963 10.6002 22.1781 10.6588ZM120.249 13.4473C118.342 13.9276 116.723 14.8324 115.356 16.1811L114.603 16.9243L117.385 33.3208C119.934 48.3395 120.173 49.8768 120.234 51.6165C120.33 54.3439 119.963 56.118 118.82 58.4537C117.848 60.4381 116.202 62.3938 114.416 63.6831L113.441 64.3873L113.798 64.6923C115.179 65.8711 116.944 66.729 118.669 67.0591C120.199 67.3519 151.335 69.3231 153.028 69.2342C154.592 69.1521 155.452 68.9266 156.921 68.2125C159.908 66.7608 162.085 63.9044 162.682 60.6524C163.01 58.8628 164.948 27.3044 164.849 25.3441C164.771 23.7722 164.551 22.875 163.89 21.4257C162.455 18.276 159.657 16.0399 156.361 15.409C155.191 15.1848 124.472 13.183 122.437 13.1983C121.671 13.204 120.839 13.2987 120.249 13.4473ZM226.384 16.4399C221.839 17.0209 218.283 20.155 217.158 24.5727C216.944 25.4143 216.815 27.6906 216.123 42.841C215.257 61.7926 215.263 61.1629 215.934 63.2017C217.136 66.8533 220.299 69.6624 223.974 70.3408C224.687 70.4725 230.351 70.7858 241.587 71.3153C257.714 72.0754 258.181 72.0906 259.358 71.8931C261.519 71.5305 263.285 70.6334 264.864 69.0967C265.85 68.1377 266.639 67.0794 267.156 66.0261C267.55 65.2222 268.04 63.5092 268.146 62.5686C268.305 61.1523 269.724 28.7941 269.666 27.9301C269.58 26.6769 269.265 25.4589 268.706 24.2244C267.058 20.5836 263.789 18.2596 259.869 17.9424C258.802 17.8561 226.917 16.3427 226.817 16.3736C226.783 16.3839 226.588 16.4138 226.384 16.4399ZM193.381 23.5104C195.212 23.9005 197.002 24.792 198.428 26.0238C200.052 27.4263 201.355 30.0989 201.355 32.0264C201.355 32.6114 201.325 32.6964 201.139 32.6438C201.02 32.6101 199.742 32.4516 198.3 32.2913L195.677 32.0001L195.596 31.6158C195.342 30.4097 194.318 29.2359 193.092 28.7449C192.53 28.5199 192.128 28.4634 191.032 28.4558C189.74 28.4467 189.629 28.4668 188.869 28.8516C186.694 29.9526 185.531 32.2707 185.325 35.9187C185.117 39.6017 186.655 42.1495 189.455 42.7572C192.33 43.3812 194.594 42.3155 195.225 40.0408C195.331 39.6613 195.404 39.3408 195.389 39.3285C195.373 39.3164 194.343 39.192 193.1 39.0522C191.857 38.9125 190.819 38.7762 190.792 38.7493C190.73 38.6854 191.194 34.6975 191.274 34.6164C191.345 34.5433 201.075 35.6276 201.231 35.726C201.365 35.8111 200.925 39.6756 200.664 40.7101C199.615 44.8543 196.372 47.6435 192.197 47.9912C188.082 48.3338 184.139 46.8163 181.951 44.0482C180.779 42.5658 179.975 40.6882 179.66 38.7019C178.943 34.1844 180.33 29.1415 183.055 26.3496C185.622 23.7198 189.439 22.6704 193.381 23.5104ZM299.366 27.1427C299.414 28.4167 299.446 29.4716 299.436 29.4871C299.426 29.5025 297.03 29.6082 294.11 29.7222C291.191 29.836 288.782 29.9481 288.758 29.9711C288.734 29.9942 288.755 31.0991 288.805 32.4265L288.895 34.8402L289.467 34.8363C289.781 34.8341 291.985 34.7533 294.364 34.6568C296.743 34.5604 298.711 34.5033 298.737 34.53C298.818 34.6128 298.96 39.0768 298.885 39.1677C298.846 39.2149 297.034 39.3161 294.858 39.3926C292.683 39.4689 290.491 39.5641 289.988 39.604L289.073 39.6767L289.158 42.0951C289.205 43.4252 289.255 44.5256 289.27 44.5404C289.284 44.5554 291.675 44.4783 294.582 44.3691C297.489 44.26 299.89 44.1938 299.917 44.2219C299.943 44.25 300.006 45.307 300.055 46.5708L300.145 48.8687L299.108 48.9438C297.73 49.0437 283.777 49.5499 283.731 49.5018C283.695 49.4633 282.817 25.4206 282.851 25.3912C282.888 25.3586 299.186 24.766 299.23 24.7958C299.256 24.8126 299.317 25.8687 299.366 27.1427ZM34.9251 25.7902C37.7787 25.8954 40.4485 26.0363 40.8579 26.1034C42.5098 26.3738 44.1415 27.072 45.0627 27.9026C47.1538 29.7882 47.4632 33.2481 45.7399 35.4769C45.2072 36.1659 44.0619 36.9104 43.101 37.1924C42.6506 37.3245 42.282 37.467 42.282 37.5089C42.282 37.551 42.6017 37.6573 42.9927 37.7455C46.6612 38.5714 48.4649 42.5972 46.7897 46.2204C45.8049 48.3501 43.7889 49.653 40.8821 50.0383C40.1929 50.1296 28.5717 49.8185 28.4518 49.7055C28.4067 49.663 28.961 31.7216 29.139 27.4649C29.2138 25.6768 29.2281 25.5974 29.4768 25.5981C29.6197 25.5985 32.0714 25.685 34.9251 25.7902ZM90.8433 26.441C95.5294 27.4386 98.6747 31.3501 99.5129 37.2229C99.708 38.5891 99.6032 41.7253 99.3282 42.7535C98.9559 44.1453 97.877 46.2171 97.0349 47.1576C94.7068 49.7573 91.8048 50.9912 88.0758 50.9667C86.5743 50.957 86.1995 50.9105 85.2427 50.6155C83.1856 49.9814 81.817 49.1346 80.4506 47.6508C78.3254 45.3432 77.1943 42.2508 77.0494 38.3528C76.9476 35.6128 77.2697 33.9754 78.3095 31.9484C80.488 27.7017 85.8 25.3674 90.8433 26.441ZM133.561 28.6992C138.952 29.0452 139.653 29.1656 141.398 30.0446C143.26 30.9816 144.642 32.758 145.132 34.8402C145.362 35.8207 145.332 38.1321 145.076 39.145C144.559 41.1887 143.322 42.8719 141.709 43.7263C141.272 43.9573 140.917 44.2033 140.919 44.2729C140.921 44.3425 141.859 46.4507 143.003 48.9576L145.084 53.5157L144.575 53.5509C143.988 53.5916 138.964 53.2729 138.896 53.1907C138.871 53.1606 138.03 51.2841 137.027 49.0209C136.023 46.7577 135.163 44.8625 135.115 44.8094C135.067 44.7563 134.409 44.6766 133.652 44.6322L132.277 44.5516L132.215 44.8553C132.181 45.0225 132.06 46.84 131.946 48.8943C131.832 50.9486 131.704 52.6649 131.661 52.7082C131.586 52.7843 126.4 52.4837 126.139 52.3881C126.052 52.3563 126.246 48.4624 126.733 40.4569C127.13 33.9206 127.475 28.5095 127.5 28.4321C127.528 28.3453 127.774 28.3102 128.143 28.3406C128.471 28.3677 130.909 28.529 133.561 28.6992ZM34.6997 32.1386C34.6552 33.0894 34.6188 34.277 34.6188 34.7776V35.6881L36.3976 35.7742C38.7528 35.8882 39.5824 35.6998 40.3202 34.8831C40.8167 34.3336 40.9617 33.9579 40.9712 33.1958C40.9834 32.2164 40.6435 31.592 39.8204 31.0823C39.1181 30.6475 38.8458 30.6018 36.2138 30.4774L34.7807 30.4098L34.6997 32.1386ZM87.1488 31.4238C84.9578 31.814 83.3872 33.3616 82.9391 35.5721C82.8471 36.0259 82.8162 36.8871 82.8565 37.8789C83.0852 43.5166 85.991 46.7112 89.9335 45.6593C91.5202 45.2359 92.6042 44.3619 93.2233 43.0066C94.0687 41.1562 94.0356 38.3443 93.1358 35.5768C92.1347 32.4972 89.8849 30.9367 87.1488 31.4238ZM236.21 31.6518L238.002 31.7381L237.975 32.2446C237.798 35.5048 237.163 51.0507 237.205 51.0884C237.236 51.116 239.43 51.2376 242.081 51.3583C244.732 51.4793 246.911 51.5869 246.923 51.5976C246.953 51.6259 246.716 56.281 246.682 56.3132C246.625 56.369 231.346 55.6026 231.286 55.5409C231.224 55.4768 232.238 31.8608 232.314 31.6019C232.34 31.5135 232.717 31.4833 233.386 31.5156C233.954 31.543 235.225 31.6043 236.21 31.6518ZM132.881 33.6315C132.881 33.7543 132.795 35.1943 132.69 36.8317C132.584 38.4689 132.524 39.8345 132.555 39.8662C132.586 39.8979 133.394 39.9797 134.35 40.0478C136.643 40.2113 137.598 40.0434 138.424 39.3316C139.655 38.2704 139.749 35.8211 138.603 34.6952C137.732 33.8402 136.981 33.621 134.483 33.4915C133.004 33.4149 132.881 33.4257 132.881 33.6315ZM34.4498 40.1701C34.4124 40.5464 34.3544 41.8313 34.3209 43.0254L34.2601 45.1964L36.1853 45.2889C38.5542 45.4026 39.2804 45.3319 40.1336 44.9042C41.0454 44.4473 41.4178 43.8 41.4141 42.6791C41.4107 41.671 41.1213 40.9778 40.4748 40.4303C39.7573 39.8223 39.039 39.6606 36.6452 39.5682L34.5177 39.4859L34.4498 40.1701Z" fill="white"/>
              <circle cx="14" cy="14" r="12.5" fill="#FDE047" stroke="#1E293B" stroke-width="3"/>
              <circle cx="171" cy="65" r="12.5" fill="#FDE047" stroke="#1E293B" stroke-width="3"/>
              <circle cx="264" cy="14" r="12.5" fill="#FDE047" stroke="#1E293B" stroke-width="3"/>
              <path d="M318.215 19.3514C318.025 20.356 317.851 21.3637 317.694 22.374C316.844 22.4702 316.008 22.6777 315.208 22.9926C313.992 23.4718 312.883 24.1898 311.949 25.1044C311.015 26.019 310.273 27.1116 309.768 28.3176C309.263 29.5236 309.004 30.8186 309.008 32.1262C309.012 33.4337 309.277 34.7272 309.789 35.9304C310.301 37.1335 311.049 38.2219 311.989 39.1312C312.928 40.0404 314.041 40.7522 315.26 41.2245C316.093 41.5472 316.965 41.7536 317.85 41.8394C319.021 46.2773 321.101 49.2558 323.508 50.8002L322.812 54.4789L319.935 54.6453C319.934 54.6454 319.933 54.6454 319.932 54.6455C319.18 54.6877 318.443 54.8815 317.768 55.2128L317.768 55.2129L312.072 58.0114C312.072 58.0114 312.071 58.0115 312.071 58.0115C311.529 58.278 311.084 58.7085 310.799 59.2421C310.515 59.7757 310.405 60.3852 310.487 60.9844C310.568 61.5837 310.835 62.1421 311.252 62.5808C311.668 63.0194 312.212 63.3159 312.806 63.4284L339.946 68.5649C340.54 68.6773 341.155 68.6 341.702 68.3438C342.25 68.0876 342.703 67.6656 342.998 67.1375C343.292 66.6094 343.413 66.002 343.344 65.4013C343.274 64.8008 343.017 64.2374 342.609 63.791C342.609 63.7909 342.609 63.7908 342.609 63.7908L338.329 59.1042L338.329 59.104C337.822 58.549 337.207 58.0994 336.522 57.7854C336.521 57.785 336.521 57.7846 336.52 57.7842L333.902 56.5777L334.598 52.899C337.403 52.3411 340.429 50.329 343.14 46.6274C343.995 46.8702 344.881 46.9958 345.774 46.9992C347.081 47.0042 348.375 46.7476 349.581 46.2444C350.787 45.7412 351.88 45.0016 352.795 44.0694C353.71 43.1371 354.43 42.031 354.911 40.8162C355.392 39.6014 355.625 38.3026 355.596 36.9964C355.567 35.6902 355.277 34.4029 354.743 33.2106C354.209 32.0183 353.441 30.945 352.485 30.0541C351.857 29.4681 351.155 28.9688 350.399 28.5678C350.614 27.6025 350.82 26.5998 351.017 25.5594C351.159 24.8086 350.997 24.0321 350.567 23.4007C350.137 22.7694 349.473 22.3348 348.722 22.1928L321.582 17.0563C320.831 16.9142 320.055 17.0762 319.423 17.5066C318.792 17.9369 318.358 18.6002 318.216 19.3507L318.215 19.3514ZM316.981 28.4235C316.777 31.1355 316.763 33.5666 316.906 35.7415C316.482 35.5419 316.092 35.268 315.756 34.9282C315.006 34.1688 314.588 33.1425 314.595 32.0751C314.601 31.0077 315.032 29.9865 315.791 29.2363C316.139 28.8927 316.543 28.6188 316.981 28.4235ZM347.617 40.958C347.18 41.1518 346.716 41.2643 346.248 41.2949C347.175 39.3229 348.051 37.0555 348.853 34.455C349.19 34.7971 349.466 35.1998 349.665 35.6471C350.097 36.6229 350.125 37.7307 349.741 38.7267C349.357 39.7226 348.593 40.5253 347.617 40.958Z" fill="#FDE047" stroke="#1E293B" stroke-width="3"/>
            </svg>

            <svg v-else width="321" height="79" viewBox="0 0 321 79" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M174.884 7.11466C170.734 7.83193 167.352 10.9674 166.311 15.0604C166.21 15.4584 166.067 16.2845 165.995 16.8963L165.863 18.0088L166.614 19.5557C167.028 20.4065 167.503 21.6018 167.671 22.2121C168.307 24.5239 168.316 24.106 167.222 42.0508L166.223 58.441L166.549 58.7275C167.188 59.2912 168.558 60.0299 169.665 60.4081C170.719 60.7683 171.847 60.9138 187.378 62.6936C196.501 63.739 204.31 64.5924 204.731 64.59C207.038 64.5767 209.477 63.6357 211.372 62.0268L212.18 61.3406L212.135 60.4668C212.074 59.2963 213.552 26.5661 213.723 25.2929C214.094 22.5356 215.379 19.6891 217.123 17.7588L217.778 17.0345L217.384 16.3137C215.883 13.5651 213.62 11.738 210.754 10.9608C209.852 10.7161 177.34 6.9807 176.28 7.00008C175.829 7.00818 175.201 7.05984 174.884 7.11466ZM100.191 9.23152C99.6191 9.29128 67.5033 14.9394 67.295 15.0169C67.2081 15.0492 67.3847 15.5461 67.7623 16.3319C68.6589 18.1974 68.9972 19.6629 69.0683 21.9889C69.1321 24.0785 68.1962 54.2344 68.0014 56.3645C67.8427 58.1005 67.4 59.6475 66.5702 61.3658L65.8977 62.7585L66.2953 63.4464C66.514 63.8247 67.1379 64.5968 67.6818 65.162C69.2472 66.7889 71.0664 67.8023 73.1619 68.2144C75.1221 68.6 75.1609 68.5947 92.512 65.5398C101.425 63.9706 109.023 62.5984 109.397 62.4902C114.02 61.1536 117.279 56.5344 117.025 51.6798C116.945 50.1553 111.487 17.7022 111.126 16.6028C110.039 13.2981 107.367 10.6422 104.139 9.65871C103.308 9.40523 101.447 9.11516 100.933 9.15884C100.796 9.17062 100.462 9.20328 100.191 9.23152ZM292.634 10.1469C281.305 10.5822 276.403 10.8143 275.699 10.9483C272.436 11.5699 269.619 13.7488 268.122 16.8092L267.745 17.5803L268.676 18.5185C269.907 19.7592 270.675 20.805 271.375 22.1939C272.476 24.3773 272.919 26.2501 272.919 28.7183C272.919 29.8905 271.702 58.0346 271.52 61.0884L271.468 61.9505L272.193 62.5513C273.258 63.4339 274.717 64.1812 276.097 64.55C277.704 64.98 277.581 64.9816 296.156 64.285C307.786 63.8489 311.785 63.6593 312.531 63.5083C316.995 62.6049 320.425 58.8602 320.989 54.2754C321.125 53.1713 319.969 19.742 319.752 18.507C319.399 16.4945 318.427 14.5155 317.067 13.0389C315.094 10.8956 312.649 9.73949 309.786 9.59515C309.122 9.56173 301.403 9.81002 292.634 10.1469ZM22.1781 10.6588C17.2338 11.352 13.3799 15.5949 13.0431 20.7159C12.9323 22.3989 12 51.7146 12 53.5131C12 54.429 12.0603 55.5125 12.134 55.9209C12.9064 60.2009 16.2759 63.6736 20.4819 64.5239C21.8765 64.8057 54.3317 65.9216 55.6529 65.7331C60.047 65.1058 63.6518 61.7033 64.5889 57.2983C64.867 55.991 65.9746 22.6894 65.7913 21.1441C65.6288 19.7738 65.0911 18.1536 64.4079 16.9753C63.4678 15.3544 61.6383 13.6082 59.9947 12.7628C59.21 12.3591 57.5379 11.8566 56.6196 11.7483C56.2457 11.7043 49.2654 11.4432 41.1078 11.1681C32.9502 10.8931 25.5249 10.642 24.6072 10.6101C23.6895 10.5783 22.5963 10.6002 22.1781 10.6588ZM120.249 13.4473C118.342 13.9276 116.723 14.8324 115.356 16.1811L114.603 16.9243L117.385 33.3208C119.934 48.3395 120.173 49.8768 120.234 51.6165C120.33 54.3439 119.963 56.118 118.82 58.4537C117.848 60.4381 116.202 62.3938 114.416 63.6831L113.441 64.3873L113.798 64.6923C115.179 65.8711 116.944 66.729 118.669 67.0591C120.199 67.3519 151.335 69.3231 153.028 69.2342C154.592 69.1521 155.452 68.9266 156.921 68.2125C159.908 66.7608 162.085 63.9044 162.682 60.6524C163.01 58.8628 164.948 27.3044 164.849 25.3441C164.771 23.7722 164.551 22.875 163.89 21.4257C162.455 18.276 159.657 16.0399 156.361 15.409C155.191 15.1848 124.472 13.183 122.437 13.1983C121.671 13.204 120.839 13.2987 120.249 13.4473ZM226.384 16.4399C221.839 17.0209 218.283 20.155 217.158 24.5727C216.944 25.4143 216.815 27.6906 216.123 42.841C215.257 61.7926 215.263 61.1629 215.934 63.2017C217.136 66.8533 220.299 69.6624 223.974 70.3408C224.687 70.4725 230.351 70.7858 241.587 71.3153C257.714 72.0754 258.181 72.0906 259.358 71.8931C261.519 71.5305 263.285 70.6334 264.864 69.0967C265.85 68.1377 266.639 67.0793 267.156 66.0261C267.55 65.2222 268.04 63.5092 268.146 62.5686C268.305 61.1523 269.724 28.7941 269.666 27.9301C269.58 26.6769 269.265 25.4589 268.706 24.2244C267.058 20.5836 263.789 18.2596 259.869 17.9424C258.802 17.8561 226.917 16.3427 226.817 16.3736C226.783 16.3839 226.588 16.4138 226.384 16.4399ZM193.381 23.5104C195.212 23.9005 197.002 24.792 198.428 26.0238C200.052 27.4263 201.355 30.0989 201.355 32.0264C201.355 32.6114 201.325 32.6964 201.139 32.6438C201.02 32.6101 199.742 32.4516 198.3 32.2913L195.677 32.0001L195.596 31.6158C195.342 30.4097 194.318 29.2359 193.092 28.7449C192.53 28.5199 192.128 28.4634 191.032 28.4558C189.74 28.4467 189.629 28.4668 188.869 28.8516C186.694 29.9526 185.531 32.2707 185.325 35.9187C185.117 39.6017 186.655 42.1495 189.455 42.7572C192.33 43.3812 194.594 42.3155 195.225 40.0408C195.331 39.6613 195.404 39.3408 195.389 39.3285C195.373 39.3164 194.343 39.192 193.1 39.0522C191.857 38.9125 190.819 38.7762 190.792 38.7493C190.73 38.6854 191.194 34.6975 191.274 34.6164C191.345 34.5433 201.075 35.6276 201.231 35.726C201.365 35.8111 200.925 39.6756 200.664 40.7101C199.615 44.8543 196.372 47.6435 192.197 47.9912C188.082 48.3338 184.139 46.8163 181.951 44.0482C180.779 42.5658 179.975 40.6882 179.66 38.7019C178.943 34.1844 180.33 29.1415 183.055 26.3496C185.622 23.7198 189.439 22.6704 193.381 23.5104ZM299.366 27.1427C299.414 28.4167 299.446 29.4716 299.436 29.4871C299.426 29.5025 297.03 29.6082 294.11 29.7222C291.191 29.836 288.782 29.9481 288.758 29.9711C288.734 29.9942 288.755 31.0991 288.805 32.4265L288.895 34.8402L289.467 34.8363C289.781 34.8341 291.985 34.7533 294.364 34.6568C296.743 34.5604 298.711 34.5033 298.737 34.53C298.818 34.6128 298.96 39.0768 298.885 39.1677C298.846 39.2149 297.034 39.3161 294.858 39.3926C292.683 39.4689 290.491 39.5641 289.988 39.604L289.073 39.6767L289.158 42.0951C289.205 43.4252 289.255 44.5256 289.27 44.5404C289.284 44.5554 291.675 44.4783 294.582 44.3691C297.489 44.26 299.89 44.1938 299.917 44.2219C299.943 44.25 300.006 45.307 300.055 46.5708L300.145 48.8687L299.108 48.9438C297.73 49.0437 283.777 49.5499 283.731 49.5018C283.695 49.4633 282.817 25.4206 282.851 25.3912C282.888 25.3586 299.186 24.766 299.23 24.7958C299.256 24.8126 299.317 25.8687 299.366 27.1427ZM34.9251 25.7902C37.7787 25.8954 40.4485 26.0363 40.8579 26.1034C42.5098 26.3738 44.1415 27.072 45.0627 27.9026C47.1538 29.7882 47.4632 33.2481 45.7399 35.4769C45.2072 36.1659 44.0619 36.9104 43.101 37.1924C42.6506 37.3245 42.282 37.467 42.282 37.5089C42.282 37.551 42.6017 37.6573 42.9927 37.7455C46.6612 38.5714 48.4649 42.5972 46.7897 46.2204C45.8049 48.3501 43.7889 49.653 40.8821 50.0383C40.1929 50.1296 28.5717 49.8185 28.4518 49.7055C28.4067 49.663 28.961 31.7216 29.139 27.4649C29.2138 25.6768 29.2281 25.5974 29.4768 25.5981C29.6197 25.5985 32.0714 25.685 34.9251 25.7902ZM90.8433 26.441C95.5294 27.4386 98.6747 31.3501 99.5129 37.2229C99.708 38.5891 99.6032 41.7253 99.3282 42.7535C98.9559 44.1453 97.877 46.2171 97.0349 47.1576C94.7068 49.7573 91.8048 50.9912 88.0758 50.9667C86.5743 50.957 86.1995 50.9105 85.2427 50.6155C83.1856 49.9814 81.817 49.1346 80.4506 47.6508C78.3254 45.3432 77.1943 42.2508 77.0494 38.3528C76.9476 35.6128 77.2697 33.9754 78.3095 31.9484C80.488 27.7017 85.8 25.3674 90.8433 26.441ZM133.561 28.6992C138.952 29.0452 139.653 29.1656 141.398 30.0446C143.26 30.9816 144.642 32.758 145.132 34.8402C145.362 35.8207 145.332 38.1321 145.076 39.145C144.559 41.1887 143.322 42.8719 141.709 43.7263C141.272 43.9573 140.917 44.2033 140.919 44.2729C140.921 44.3425 141.859 46.4507 143.003 48.9576L145.084 53.5157L144.575 53.5509C143.988 53.5916 138.964 53.2729 138.896 53.1907C138.871 53.1606 138.03 51.2841 137.027 49.0209C136.023 46.7577 135.163 44.8625 135.115 44.8094C135.067 44.7563 134.409 44.6766 133.652 44.6322L132.277 44.5516L132.215 44.8553C132.181 45.0225 132.06 46.84 131.946 48.8943C131.832 50.9486 131.704 52.6649 131.661 52.7082C131.586 52.7843 126.4 52.4837 126.139 52.3881C126.052 52.3563 126.246 48.4624 126.733 40.4569C127.13 33.9206 127.475 28.5095 127.5 28.4321C127.528 28.3453 127.774 28.3102 128.143 28.3406C128.471 28.3677 130.909 28.529 133.561 28.6992ZM34.6997 32.1386C34.6552 33.0894 34.6188 34.277 34.6188 34.7776V35.6881L36.3976 35.7742C38.7528 35.8882 39.5824 35.6998 40.3202 34.8831C40.8167 34.3336 40.9617 33.9579 40.9712 33.1958C40.9834 32.2164 40.6435 31.592 39.8204 31.0823C39.1181 30.6475 38.8458 30.6018 36.2138 30.4774L34.7807 30.4098L34.6997 32.1386ZM87.1488 31.4238C84.9578 31.814 83.3872 33.3616 82.9391 35.5721C82.8471 36.0259 82.8162 36.8871 82.8565 37.8789C83.0852 43.5166 85.991 46.7112 89.9335 45.6593C91.5202 45.2359 92.6042 44.3619 93.2233 43.0066C94.0687 41.1562 94.0356 38.3443 93.1358 35.5768C92.1347 32.4972 89.8849 30.9367 87.1488 31.4238ZM236.21 31.6518L238.002 31.7381L237.975 32.2446C237.798 35.5048 237.163 51.0507 237.205 51.0884C237.236 51.116 239.43 51.2376 242.081 51.3583C244.732 51.4793 246.911 51.5869 246.923 51.5976C246.953 51.6259 246.716 56.281 246.682 56.3132C246.625 56.369 231.346 55.6026 231.286 55.5409C231.224 55.4768 232.238 31.8608 232.314 31.6019C232.34 31.5135 232.717 31.4833 233.386 31.5156C233.954 31.543 235.225 31.6043 236.21 31.6518ZM132.881 33.6315C132.881 33.7543 132.795 35.1943 132.69 36.8317C132.584 38.4689 132.524 39.8345 132.555 39.8662C132.586 39.8979 133.394 39.9797 134.35 40.0478C136.643 40.2113 137.598 40.0434 138.424 39.3316C139.655 38.2704 139.749 35.8211 138.603 34.6952C137.732 33.8402 136.981 33.621 134.483 33.4915C133.004 33.4149 132.881 33.4257 132.881 33.6315ZM34.4498 40.1701C34.4124 40.5464 34.3544 41.8313 34.3209 43.0254L34.2601 45.1964L36.1853 45.2889C38.5542 45.4026 39.2804 45.3319 40.1336 44.9042C41.0454 44.4473 41.4178 43.8 41.4141 42.6791C41.4107 41.671 41.1213 40.9778 40.4748 40.4303C39.7573 39.8223 39.039 39.6606 36.6452 39.5682L34.5177 39.4859L34.4498 40.1701Z" fill="white"/>
              <circle cx="14" cy="14" r="12.5" fill="#10B981" stroke="#1E293B" stroke-width="3"/>
              <circle cx="171" cy="65" r="12.5" fill="#3B82F6" stroke="#1E293B" stroke-width="3"/>
              <circle cx="264" cy="14" r="12.5" fill="#8B5CF6" stroke="#1E293B" stroke-width="3"/>
            </svg>
          </div>
          <div id="modalInfoRow" class="infoRow">
            <p><span class="bold">www.borgle.xyz</span></p>
            <p class="separator">|</p>
            <p>{{ $date(date).format('M') }}/{{ $date(date).format('D')}}/{{ $date(date).format('YY') }}</p>
            <p class="separator">|</p>
            <button
              type="button"
              id="shareTextResults"
              class="button alt"
              @click="shareTextResults()"
              v-tooltip="{
                content: 'Copied to clipboard!',
                trigger: 'manual',
                show: this.clipboardTooltip}">
                  {{this.userData.results.won ? "Share Win" : "Share Score"}}
              </button>
          </div>

          <hr>

          <div id="modalTotalWords">

            <div class="rowHeader large">
              <h3><span class="bold">{{userData.results.score}} {{userData.results.score === 1? "Word" : "Words"}}</span> Found</h3>
              <h3 v-if="!this.userData.results.won">{{userData.results.goalPercentage}}% of Goal</h3>
              <h3 v-else><span class="bold gold">{{userData.results.goalPercentage}}%</span> of Goal</h3>
            </div>

            <div id="simplifiedWords">
              <SimplifiedWord
              v-for="(wordObj, i) in userData.submittedWords"
              :key="i+wordObj.word"
              :word="wordObj.word"
              :difficulty="wordObj.difficulty" />
            </div>
          </div>

          <hr>

          <div class="rowHeader large"  v-if="this.userData.submittedWords.length != 0">
            <h3>Word Breakdown</h3>
          </div>

          <div id="modalWordBreakdown" v-if="this.userData.submittedWords.length != 0">
            <div id="wordBars">
              <div
              class="wordBar easy"
              v-if="(this.userData.results.easyScore > 0)"
              :style="{width: Math.round((this.userData.results.easyScore / this.userData.results.score) * 100) + '%'}"
              v-tooltip="{
                content: `${this.userData.results.easyScore} words`,
                trigger: 'hover click'}"/>

              <div class="wordBar hard"
              v-if="(this.userData.results.hardScore > 0)"
              :style="{width: Math.round((this.userData.results.hardScore / this.userData.results.score) * 100) + '%'}"
              v-tooltip="{
                content: `${this.userData.results.hardScore} words`,
                trigger: 'hover click'}"/>

              <div class="wordBar impossible"
              v-if="(this.userData.results.impossibleScore > 0)"
              :style="{width: Math.round((this.userData.results.impossibleScore / this.userData.results.score) * 100) + '%'}"
              v-tooltip="{
                content: `${this.userData.results.impossibleScore} words`,
                trigger: 'hover click'}"/>
            </div>

            <div class="modalBadges">

              <div class="modalBadgeRow">
                <div class="badge" v-if="(this.userData.results.easyScore > 0)"><span class="bold green">Easy</span> {{Math.round((this.userData.results.easyScore / this.userData.results.score) * 100)}}%</div>
                <div class="badge" v-if="(this.userData.results.hardScore > 0)"><span class="bold blue">Hard</span> {{Math.round((this.userData.results.hardScore / this.userData.results.score) * 100)}}%</div>
                <div class="badge" v-if="(this.userData.results.impossibleScore > 0)"><span class="bold purple">Impossible</span> {{Math.round((this.userData.results.impossibleScore / this.userData.results.score) * 100)}}%</div>
              </div>

              <div class="modalBadgeRow">

                <div class="badge"
                v-tooltip="{
                content: `${this.longestWord}`,
                trigger: 'hover click'}">
                  Longest Word: <span class="bold">{{this.longestWordFiltered}} ({{this.longestWordFiltered.length}} letters)</span>
                </div>

              </div>

            </div>

          </div>

          <hr v-if="this.userData.submittedWords.length != 0">

          <div class="rowHeader large">
            <h3>Lifetime Stats</h3>
          </div>

          <div class="modalBadges">
            <div class="modalBadgeRow">
              <div class="badge"><span class="bold">{{this.userData.streak}} Day</span> Streak</div>
              <div class="badge"><span class="bold">{{this.userData.daysPlayed}}</span> {{userData.daysPlayed === 1? "Game" : "Games"}}</div>
              <div class="badge"><span class="bold">{{this.userData.totalWins}}</span> {{userData.totalWins === 1? "Win" : "Wins"}}</div>
            </div>
            <div class="modalBadgeRow">
              <div class="badge"><span class="bold">{{this.averageWords}}</span> Average Words</div>
              <div class="badge"><span class="bold">{{this.userData.totalWordsFound}}</span> Total Words</div>
            </div>
          </div>
        </div>

      </div>
    </modal>

    <modal
    name="instructions"
    width="355"
    height="auto"
    :scrollable="true"
    @before-open="beforeModalOpen"
    @before-close="beforeModalClose">
      <div id="instructionsModal" class="modalContent">
        <div class="closeButton" @click="closeModal()"></div>

        <div class="inner">

          <div class="instructionGroup">

            <div class="rowHeader"><h3><span class="bold">How to Play Borgle</span></h3></div>
            <p>You have 3 minutes to find as many words as you can on the given board. Start with any letter, and look to any surrounding tile to continue the word. Words only count if they're <span class="bold">4+ letters</span> long.</p>
            <lottie-animation
              ref="boardAnim"
              :animationData="require('@/assets/boardAnim.json')"
              :loop="true"
              :autoPlay="true"
              :speed="1"
            />

          </div>

          <hr>

          <div class="instructionGroup">

            <div class="rowHeader"><h3><span class="bold">Goal</span></h3></div>
            <p>The words you found will be broken into <span class="bold green">easy</span>, <span class="bold blue">hard</span>, and <span class="bold purple">impossible</span> words, but your main objective is to beat the <span class="bold">word goal</span>. Today’s goal is <span class="bold">{{todaysBoard.totalGoal}} words</span>, but changes each day based on the difficulty of the board.</p>

          </div>

          <hr>

          <div class="instructionGroup">

            <div class="rowHeader"><h3><span class="bold">Wildcard Tiles</span></h3></div>
            <p>Every Sunday you'll see a square tile on the board. These wildcards can represent any letter! In the example below, there are 4 valid words.</p>
            <lottie-animation
              ref="wildcardAnim"
              :animationData="require('@/assets/wildcardAnim.json')"
              :loop="true"
              :autoPlay="true"
              :speed="1"
            />

          </div>

          <hr v-if="this.isMobile">

          <button
            v-if="this.isMobile"
            type="button"
            id="closeInstructions"
            class="button alt"
            @click="closeModal()">
              Okay!
            </button>

        </div>

      </div>

    </modal>

    <modal
    name="about"
    width="355"
    height="auto"
    :scrollable="true"
    @before-open="beforeModalOpen"
    @before-close="beforeModalClose">
      <div id="aboutModal" class="modalContent">
        <div class="closeButton" @click="closeModal()"></div>

        <div class="inner">

          <div id="aboutHeader">

            <div id="aboutLogo">
              <svg width="152" height="38" viewBox="0 0 152 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M83.0771 3.9408C81.1199 4.27914 79.5242 5.75813 79.0332 7.68881C78.9855 7.87652 78.9184 8.26622 78.8842 8.5548L78.8218 9.07954L79.1764 9.80924C79.3715 10.2105 79.5957 10.7744 79.6749 11.0622C79.9746 12.1527 79.9791 11.9556 79.4632 20.4201L78.992 28.1513L79.1454 28.2865C79.4472 28.5524 80.0934 28.9008 80.6155 29.0792C81.1128 29.2491 81.6445 29.3177 88.9707 30.1573C93.2741 30.6504 96.9573 31.053 97.1558 31.0518C98.2444 31.0455 99.3945 30.6017 100.288 29.8428L100.67 29.5191L100.648 29.1069C100.62 28.5548 101.317 13.116 101.398 12.5154C101.573 11.2148 102.179 9.87213 103.002 8.96164L103.31 8.61996L103.125 8.27996C102.416 6.98348 101.349 6.12161 99.9972 5.75503C99.5715 5.63958 84.2356 3.87762 83.7355 3.88675C83.5231 3.89058 83.2268 3.91494 83.0771 3.9408ZM47.8447 4.93932C47.5749 4.96751 32.4259 7.63172 32.3277 7.66827C32.2867 7.6835 32.37 7.91791 32.5481 8.28856C32.971 9.16852 33.1306 9.85976 33.1641 10.9569C33.1942 11.9426 32.7528 26.1671 32.6609 27.1719C32.586 27.9907 32.3772 28.7204 31.9858 29.531L31.6686 30.1879L31.8561 30.5124C31.9593 30.6908 32.2536 31.055 32.5101 31.3216C33.2485 32.089 34.1066 32.5671 35.0951 32.7615C36.0197 32.9433 36.038 32.9408 44.2225 31.4999C48.4266 30.7596 52.0106 30.1124 52.187 30.0614C54.3677 29.4309 55.9052 27.252 55.7854 24.9621C55.7477 24.243 53.173 8.93494 53.0025 8.41637C52.4898 6.85752 51.2295 5.60476 49.7071 5.14083C49.3148 5.02126 48.4372 4.88444 48.1948 4.90504C48.1299 4.91059 47.9723 4.926 47.8447 4.93932ZM138.619 5.37112C133.276 5.57645 130.963 5.68592 130.632 5.74911C129.092 6.04235 127.763 7.07014 127.057 8.51371L126.879 8.87743L127.319 9.31998C127.899 9.90521 128.262 10.3985 128.592 11.0536C129.111 12.0836 129.32 12.9669 129.32 14.1312C129.32 14.6841 128.746 27.9596 128.66 29.4001L128.636 29.8068L128.978 30.0901C129.48 30.5065 130.168 30.859 130.819 31.0329C131.577 31.2358 131.519 31.2365 140.281 30.9079C145.767 30.7023 147.653 30.6128 148.005 30.5416C150.111 30.1155 151.729 28.3491 151.995 26.1864C152.059 25.6657 151.513 9.89709 151.411 9.31455C151.245 8.36524 150.786 7.43176 150.145 6.73527C149.214 5.72427 148.061 5.17893 146.71 5.11085C146.397 5.09508 142.756 5.2122 138.619 5.37112ZM11.0461 5.61258C8.71391 5.93957 6.896 7.94091 6.73713 10.3565C6.68489 11.1503 6.24512 24.9785 6.24512 25.8268C6.24512 26.2589 6.27357 26.77 6.30832 26.9626C6.67264 28.9815 8.26207 30.6195 10.246 31.0206C10.9038 31.1536 26.2129 31.6799 26.8361 31.591C28.9088 31.2951 30.6092 29.6902 31.0512 27.6123C31.1824 26.9957 31.7048 11.2874 31.6184 10.5585C31.5417 9.91208 31.2881 9.14786 30.9658 8.59207C30.5224 7.82749 29.6594 7.00378 28.8841 6.60501C28.514 6.41461 27.7253 6.17757 27.2921 6.12651C27.1157 6.10572 23.8231 5.98257 19.9752 5.85279C16.1273 5.72307 12.6248 5.60464 12.1919 5.58959C11.759 5.5746 11.2434 5.58493 11.0461 5.61258ZM57.3061 6.92788C56.4065 7.15447 55.6426 7.58125 54.9981 8.21743L54.643 8.568L55.9552 16.3022C57.1572 23.3865 57.2702 24.1116 57.299 24.9322C57.3443 26.2188 57.1712 27.0556 56.6319 28.1573C56.1736 29.0934 55.3968 30.0159 54.5546 30.624L54.0945 30.9562L54.2631 31.1001C54.9143 31.6561 55.7471 32.0608 56.5607 32.2165C57.2823 32.3546 71.9691 33.2844 72.7675 33.2425C73.5056 33.2038 73.911 33.0974 74.6041 32.7606C76.0132 32.0758 77.0399 30.7284 77.3214 29.1945C77.4764 28.3503 78.3903 13.4643 78.3439 12.5396C78.3067 11.7981 78.2032 11.3749 77.8916 10.6913C77.2145 9.20561 75.8946 8.15084 74.3402 7.85323C73.7878 7.74746 59.2979 6.80323 58.3378 6.81046C57.9767 6.81315 57.5841 6.85782 57.3061 6.92788ZM107.37 8.3395C105.226 8.61357 103.549 10.0919 103.018 12.1757C102.917 12.5727 102.856 13.6464 102.53 20.7929C102.121 29.7323 102.124 29.4353 102.44 30.3969C103.007 32.1194 104.499 33.4445 106.233 33.7645C106.569 33.8266 109.241 33.9744 114.541 34.2241C122.148 34.5827 122.368 34.5898 122.923 34.4967C123.943 34.3256 124.776 33.9025 125.521 33.1776C125.986 32.7253 126.358 32.226 126.602 31.7292C126.788 31.35 127.019 30.542 127.069 30.0983C127.144 29.4303 127.813 14.167 127.786 13.7594C127.745 13.1683 127.596 12.5937 127.333 12.0114C126.556 10.2941 125.013 9.19785 123.165 9.04824C122.661 9.00751 107.621 8.29363 107.574 8.30821C107.558 8.3131 107.466 8.3272 107.37 8.3395ZM91.8022 11.6746C92.666 11.8587 93.5104 12.2792 94.183 12.8602C94.949 13.5218 95.5636 14.7824 95.5636 15.6916C95.5636 15.9676 95.5495 16.0076 95.4615 15.9829C95.4054 15.967 94.8029 15.8922 94.1225 15.8166L92.8854 15.6792L92.8472 15.498C92.7273 14.929 92.2443 14.3753 91.6659 14.1437C91.4009 14.0376 91.2113 14.011 90.6943 14.0074C90.0846 14.0031 90.0325 14.0126 89.674 14.1941C88.6479 14.7134 88.0995 15.8069 88.0022 17.5276C87.9039 19.2649 88.6297 20.4667 89.9503 20.7533C91.3064 21.0477 92.3742 20.545 92.6722 19.472C92.7219 19.293 92.7566 19.1418 92.7493 19.136C92.7419 19.1303 92.2562 19.0716 91.6698 19.0057C91.0834 18.9398 90.5935 18.8755 90.5812 18.8628C90.5518 18.8327 90.7708 16.9516 90.8081 16.9133C90.8418 16.8788 95.4316 17.3903 95.5049 17.4367C95.5683 17.4768 95.3609 19.2997 95.2374 19.7877C94.743 21.7425 93.213 23.0582 91.2435 23.2222C89.3028 23.3838 87.4429 22.668 86.4107 21.3623C85.858 20.663 85.4784 19.7774 85.3298 18.8404C84.992 16.7096 85.6459 14.3308 86.9315 13.0139C88.1425 11.7734 89.9426 11.2784 91.8022 11.6746ZM141.795 13.388C141.818 13.9889 141.833 14.4865 141.828 14.4938C141.824 14.5011 140.693 14.551 139.316 14.6047C137.939 14.6584 136.803 14.7113 136.792 14.7222C136.78 14.733 136.79 15.2542 136.814 15.8804L136.856 17.0189L137.126 17.017C137.274 17.016 138.313 16.9779 139.436 16.9324C140.558 16.8869 141.486 16.86 141.499 16.8726C141.537 16.9116 141.604 19.0173 141.568 19.0602C141.55 19.0824 140.695 19.1302 139.669 19.1662C138.643 19.2023 137.609 19.2472 137.372 19.266L136.94 19.3003L136.98 20.441C137.002 21.0684 137.026 21.5875 137.033 21.5945C137.04 21.6015 138.167 21.5652 139.539 21.5137C140.91 21.4622 142.042 21.431 142.055 21.4442C142.068 21.4575 142.097 21.956 142.12 22.5522L142.162 23.6361L141.674 23.6715C141.023 23.7187 134.442 23.9574 134.42 23.9347C134.403 23.9166 133.989 12.5757 134.005 12.5618C134.023 12.5464 141.71 12.2669 141.731 12.281C141.743 12.2889 141.772 12.7871 141.795 13.388ZM17.0588 12.75C18.4049 12.7997 19.6642 12.8661 19.8573 12.8978C20.6365 13.0253 21.4062 13.3547 21.8407 13.7465C22.8271 14.6359 22.973 16.2679 22.1602 17.3192C21.9089 17.6442 21.3687 17.9954 20.9154 18.1284C20.7029 18.1907 20.5291 18.258 20.5291 18.2777C20.5291 18.2976 20.6799 18.3477 20.8643 18.3893C22.5948 18.7789 23.4456 20.6778 22.6553 22.3869C22.1909 23.3915 21.2399 24.0061 19.8687 24.1878C19.5437 24.2309 14.0619 24.0841 14.0054 24.0308C13.9841 24.0108 14.2456 15.5478 14.3295 13.54C14.3648 12.6965 14.3716 12.6591 14.4889 12.6594C14.5563 12.6596 15.7128 12.7004 17.0588 12.75ZM43.4354 13.057C45.6458 13.5276 47.1294 15.3726 47.5248 18.1428C47.6168 18.7872 47.5674 20.2666 47.4377 20.7516C47.2621 21.4081 46.7531 22.3853 46.3559 22.829C45.2578 24.0553 43.8889 24.6373 42.1299 24.6257C41.4217 24.6211 41.2449 24.5992 40.7936 24.4601C39.8233 24.161 39.1777 23.7615 38.5332 23.0616C37.5307 21.9731 36.9971 20.5144 36.9288 18.6758C36.8808 17.3833 37.0327 16.611 37.5232 15.6549C38.5508 13.6517 41.0565 12.5506 43.4354 13.057ZM63.585 14.1222C66.128 14.2854 66.4587 14.3422 67.2822 14.7568C68.1601 15.1988 68.8123 16.0367 69.043 17.0189C69.1517 17.4814 69.1375 18.5717 69.0166 19.0495C68.7728 20.0135 68.1893 20.8074 67.4284 21.2105C67.2227 21.3194 67.0551 21.4354 67.0561 21.4683C67.057 21.5011 67.4994 22.4955 68.0391 23.6781L69.0205 25.8281L68.7806 25.8447C68.5037 25.8639 66.1337 25.7135 66.1017 25.6748C66.0899 25.6606 65.6931 24.7755 65.2199 23.7079C64.7467 22.6404 64.341 21.7464 64.3184 21.7213C64.2958 21.6963 63.9853 21.6587 63.6284 21.6378L62.9794 21.5997L62.9503 21.743C62.9344 21.8218 62.8772 22.6792 62.8235 23.6482C62.7696 24.6172 62.7091 25.4268 62.6889 25.4472C62.6534 25.4831 60.2076 25.3413 60.0844 25.2962C60.0434 25.2812 60.1348 23.4445 60.3643 19.6683C60.5517 16.5851 60.7146 14.0327 60.7262 13.9962C60.7393 13.9552 60.8553 13.9387 61.0293 13.953C61.1844 13.9658 62.3344 14.0419 63.585 14.1222ZM16.9525 15.7446C16.9316 16.193 16.9144 16.7532 16.9144 16.9894V17.4188L17.7534 17.4595C18.8644 17.5132 19.2557 17.4243 19.6037 17.0391C19.8379 16.7799 19.9063 16.6027 19.9108 16.2433C19.9166 15.7812 19.7562 15.4867 19.3679 15.2463C19.0367 15.0412 18.9082 15.0196 17.6667 14.961L16.9907 14.9291L16.9525 15.7446ZM41.6927 15.4074C40.6592 15.5914 39.9183 16.3214 39.7069 17.3641C39.6636 17.5782 39.649 17.9844 39.668 18.4522C39.7759 21.1116 41.1465 22.6184 43.0062 22.1223C43.7547 21.9225 44.266 21.5103 44.558 20.871C44.9568 19.9981 44.9412 18.6718 44.5167 17.3664C44.0445 15.9137 42.9833 15.1776 41.6927 15.4074ZM112.005 15.5149L112.85 15.5557L112.837 15.7945C112.754 17.3324 112.454 24.6653 112.474 24.6831C112.488 24.6962 113.523 24.7535 114.774 24.8105C116.025 24.8675 117.052 24.9183 117.058 24.9233C117.072 24.9367 116.96 27.1325 116.944 27.1477C116.917 27.174 109.71 26.8125 109.682 26.7834C109.653 26.7532 110.131 15.6135 110.167 15.4914C110.179 15.4497 110.357 15.4354 110.673 15.4507C110.94 15.4636 111.54 15.4925 112.005 15.5149ZM63.2643 16.4488C63.2643 16.5067 63.2238 17.1859 63.1742 17.9583C63.1246 18.7306 63.096 19.3747 63.1105 19.3897C63.1252 19.4046 63.5062 19.4432 63.9574 19.4753C65.039 19.5524 65.4897 19.4732 65.8792 19.1375C66.4599 18.6369 66.5043 17.4816 65.9633 16.9505C65.5525 16.5472 65.1986 16.4438 64.0199 16.3827C63.3227 16.3466 63.2643 16.3517 63.2643 16.4488ZM16.8347 19.533C16.817 19.7105 16.7897 20.3166 16.7739 20.8798L16.7452 21.9039L17.6533 21.9475C18.7707 22.0011 19.1132 21.9678 19.5157 21.7661C19.9458 21.5505 20.1214 21.2452 20.1197 20.7165C20.1181 20.241 19.9816 19.914 19.6766 19.6557C19.3382 19.3689 18.9993 19.2927 17.8702 19.2491L16.8667 19.2103L16.8347 19.533Z" fill="#64748B"/>
                <circle cx="7.18868" cy="7.18868" r="5.93868" fill="#64748B" stroke="#1E293B" stroke-width="1.5"/>
                <circle cx="81.2453" cy="31.2453" r="5.93868" fill="#64748B" stroke="#1E293B" stroke-width="1.5"/>
                <circle cx="125.113" cy="7.18868" r="5.93868" fill="#64748B" stroke="#1E293B" stroke-width="1.5"/>
              </svg>

            </div>

            <div id="credits">
              <p>Borgle Version {{this.version}}</p>
              <p>by Dan Araujo</p>
            </div>

          </div>

          <div id="buttonRow">

            <a href="https://twitter.com/borglegame" target="_blank" class="button twitter">
              <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.25 2.68332C17.5318 3.18993 16.7366 3.5774 15.895 3.83082C15.4433 3.31146 14.843 2.94334 14.1753 2.77627C13.5075 2.60919 12.8046 2.65122 12.1616 2.89666C11.5185 3.14211 10.9663 3.57912 10.5797 4.14861C10.1931 4.7181 9.99077 5.39257 10 6.08082V6.83082C8.68197 6.865 7.37596 6.57268 6.19826 5.97991C5.02056 5.38713 4.00774 4.5123 3.25 3.43332C3.25 3.43332 0.25 10.1833 7 13.1833C5.4554 14.2318 3.61537 14.7575 1.75 14.6833C8.5 18.4333 16.75 14.6833 16.75 6.05832C16.7493 5.84941 16.7292 5.64102 16.69 5.43582C17.4555 4.68094 17.9956 3.72786 18.25 2.68332Z" fill="#3B82F6" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

              Twitter
            </a>

            <a href="mailto:borglegame@gmail.com" class="button email">
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.2393 3.27581C16.8733 2.9259 16.5107 2.73291 15.9968 2.61443L15.8145 2.57241L9.58506 2.56959C6.15885 2.56805 3.29732 2.5736 3.2261 2.58194C2.66736 2.64737 2.14439 2.89944 1.74773 3.29454C1.55682 3.4847 1.43969 3.63772 1.32552 3.84614C1.26608 3.95466 1.25924 3.97824 1.28126 3.99897C1.30079 4.01735 5.42417 6.90517 9.45595 9.72415L9.50537 9.7587L13.6318 6.87026L17.7583 3.98183L17.6912 3.85922C17.5783 3.65281 17.4204 3.44899 17.2393 3.27581ZM8.99634 11.8322C8.95323 11.8052 7.14873 10.5454 4.98634 9.03261C2.82395 7.51985 1.04161 6.2771 1.02556 6.27095C0.999235 6.26084 0.99698 6.65599 1.00237 10.3163C1.00833 14.3658 1.00842 14.3731 1.04807 14.5526C1.14684 14.9997 1.32134 15.3555 1.61008 15.6984C1.97361 16.1301 2.51103 16.4332 3.09027 16.5332C3.23794 16.5587 3.97771 16.562 9.5099 16.562C15.6256 16.562 15.918 16.5697 16.1765 16.4799C16.2108 16.468 16.2444 16.4544 16.291 16.4388C16.6773 16.3097 16.9988 16.1077 17.2921 15.8098C17.6194 15.4773 17.8409 15.0659 17.9594 14.5701C17.9912 14.4372 17.9935 14.1964 17.9988 10.3466C18.0019 8.10121 17.9989 6.26409 17.9921 6.26409C17.9853 6.26409 16.1951 7.5135 14.0139 9.04058C11.8326 10.5677 9.99284 11.8441 9.92548 11.8771C9.63901 12.0174 9.26254 11.9993 8.99634 11.8322Z" fill="#FDE047"/>
              </svg>

              Email
            </a>

            <a href="https://ko-fi.com/dnlrj" target="_blank" class="button coffee">
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 6.43359H14.25C15.0456 6.43359 15.8087 6.74966 16.3713 7.31227C16.9339 7.87488 17.25 8.63794 17.25 9.43359C17.25 10.2292 16.9339 10.9923 16.3713 11.5549C15.8087 12.1175 15.0456 12.4336 14.25 12.4336H13.5" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M1.5 6.43359H13.5V13.1836C13.5 13.9792 13.1839 14.7423 12.6213 15.3049C12.0587 15.8675 11.2956 16.1836 10.5 16.1836H4.5C3.70435 16.1836 2.94129 15.8675 2.37868 15.3049C1.81607 14.7423 1.5 13.9792 1.5 13.1836V6.43359Z" fill="#10B981" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.5 1.18359V3.43359" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.5 1.18359V3.43359" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.5 1.18359V3.43359" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

              Buy Coffee
            </a>
          </div>

          <hr>

          <div id="faqSection">

            <div class="faq">
              <h3><span class="bold">When are new boards available?</span></h3>
              <p>A new board will be available every day at 12AM EST.</p>
            </div>

            <div class="faq">
              <h3><span class="bold">How is the goal determined?</span></h3>
              <p>The word goal for each day is determined by the distribution of easy, hard, and impossible words on the board. Boards full of easy words will have higher goals (up to a max of 25), while boards that are mostly populated with hard/impossible words will have lower goals (down to a minimum of 10).</p>
            </div>

            <div class="faq">
              <h3><span class="bold">What's your privacy policy?</span></h3>
              <p>Borgle won't ask you for any identifying data or record any of your data in our database, but some of your data may be automatically processed for analytics purposes through Google Analytics. For the full document, click <a href="/privacy.html">here</a>.</p>
            </div>

          </div>

          <hr v-if="this.isMobile">

          <div class="buttonContainer" v-if="this.isMobile">
            <button
            type="button"
            id="closeAbout"
            class="button alt"
            @click="closeModal()">
              Okay!
            </button>
          </div>

        </div>
      </div>

    </modal>

    <modal
    name="warning"
    width="355"
    height="auto"
    :scrollable="true"
    :clickToClose="false"
    @before-open="beforeModalOpen"
    @before-close="beforeModalClose">
      <div id="warningModal" class="modalContent">

        <div class="inner">
          <h2>Hang on a sec!</h2>
          <p><b>The good news is...</b> you can still play Borgle today. Don't worry!</p>
          <p><b>The bad news is...</b> it might take a minute. A service that Borgle is dependent on has been experiencing slow connection times. Because of this, the game will load significantly slower. Bummer.</p>
          <p><b>Leave this tab open</b> and <b class="green">check back in 45-60 seconds</b>. Once today's board is ready, this window will disappear. Sorry for the inconvenience.</p>
          <p>Happy borgling,<br/>Management</p>
        </div>

      </div>

    </modal>

    <div v-if="this.compressedLayout" id="compressedLogo" >
      <svg width="100%" height="100%" viewBox="0 0 321 79" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M174.884 7.11466C170.734 7.83193 167.352 10.9674 166.311 15.0604C166.21 15.4584 166.067 16.2845 165.995 16.8963L165.863 18.0088L166.614 19.5557C167.028 20.4065 167.503 21.6018 167.671 22.2121C168.307 24.5239 168.316 24.106 167.222 42.0508L166.223 58.441L166.549 58.7275C167.188 59.2912 168.558 60.0299 169.665 60.4081C170.719 60.7683 171.847 60.9138 187.378 62.6936C196.501 63.739 204.31 64.5924 204.731 64.59C207.038 64.5767 209.477 63.6357 211.372 62.0268L212.18 61.3406L212.135 60.4668C212.074 59.2963 213.552 26.5661 213.723 25.2929C214.094 22.5356 215.379 19.6891 217.123 17.7588L217.778 17.0345L217.384 16.3137C215.883 13.5651 213.62 11.738 210.754 10.9608C209.852 10.7161 177.34 6.9807 176.28 7.00008C175.829 7.00818 175.201 7.05984 174.884 7.11466ZM100.191 9.23152C99.6191 9.29128 67.5033 14.9394 67.295 15.0169C67.2081 15.0492 67.3847 15.5461 67.7623 16.3319C68.6589 18.1974 68.9972 19.6629 69.0683 21.9889C69.1321 24.0785 68.1962 54.2344 68.0014 56.3645C67.8427 58.1005 67.4 59.6475 66.5702 61.3658L65.8977 62.7585L66.2953 63.4464C66.514 63.8247 67.1379 64.5968 67.6818 65.162C69.2472 66.7889 71.0664 67.8023 73.1619 68.2144C75.1221 68.6 75.1609 68.5947 92.512 65.5398C101.425 63.9706 109.023 62.5984 109.397 62.4902C114.02 61.1536 117.279 56.5344 117.025 51.6798C116.945 50.1553 111.487 17.7022 111.126 16.6028C110.039 13.2981 107.367 10.6422 104.139 9.65871C103.308 9.40523 101.447 9.11516 100.933 9.15884C100.796 9.17062 100.462 9.20328 100.191 9.23152ZM292.634 10.1469C281.305 10.5822 276.403 10.8143 275.699 10.9483C272.436 11.5699 269.619 13.7488 268.122 16.8092L267.745 17.5803L268.676 18.5185C269.907 19.7592 270.675 20.805 271.375 22.1939C272.476 24.3773 272.919 26.2501 272.919 28.7183C272.919 29.8905 271.702 58.0346 271.52 61.0884L271.468 61.9505L272.193 62.5513C273.258 63.4339 274.717 64.1812 276.097 64.55C277.704 64.98 277.581 64.9816 296.156 64.285C307.786 63.8489 311.785 63.6593 312.531 63.5083C316.995 62.6049 320.425 58.8602 320.989 54.2754C321.125 53.1713 319.969 19.742 319.752 18.507C319.399 16.4945 318.427 14.5155 317.067 13.0389C315.094 10.8956 312.649 9.73949 309.786 9.59515C309.122 9.56173 301.403 9.81002 292.634 10.1469ZM22.1781 10.6588C17.2338 11.352 13.3799 15.5949 13.0431 20.7159C12.9323 22.3989 12 51.7146 12 53.5131C12 54.429 12.0603 55.5125 12.134 55.9209C12.9064 60.2009 16.2759 63.6736 20.4819 64.5239C21.8765 64.8057 54.3317 65.9216 55.6529 65.7331C60.047 65.1058 63.6518 61.7033 64.5889 57.2983C64.867 55.991 65.9746 22.6894 65.7913 21.1441C65.6288 19.7738 65.0911 18.1536 64.4079 16.9753C63.4678 15.3544 61.6383 13.6082 59.9947 12.7628C59.21 12.3591 57.5379 11.8566 56.6196 11.7483C56.2457 11.7043 49.2654 11.4432 41.1078 11.1681C32.9502 10.8931 25.5249 10.642 24.6072 10.6101C23.6895 10.5783 22.5963 10.6002 22.1781 10.6588ZM120.249 13.4473C118.342 13.9276 116.723 14.8324 115.356 16.1811L114.603 16.9243L117.385 33.3208C119.934 48.3395 120.173 49.8768 120.234 51.6165C120.33 54.3439 119.963 56.118 118.82 58.4537C117.848 60.4381 116.202 62.3938 114.416 63.6831L113.441 64.3873L113.798 64.6923C115.179 65.8711 116.944 66.729 118.669 67.0591C120.199 67.3519 151.335 69.3231 153.028 69.2342C154.592 69.1521 155.452 68.9266 156.921 68.2125C159.908 66.7608 162.085 63.9044 162.682 60.6524C163.01 58.8628 164.948 27.3044 164.849 25.3441C164.771 23.7722 164.551 22.875 163.89 21.4257C162.455 18.276 159.657 16.0399 156.361 15.409C155.191 15.1848 124.472 13.183 122.437 13.1983C121.671 13.204 120.839 13.2987 120.249 13.4473ZM226.384 16.4399C221.839 17.0209 218.283 20.155 217.158 24.5727C216.944 25.4143 216.815 27.6906 216.123 42.841C215.257 61.7926 215.263 61.1629 215.934 63.2017C217.136 66.8533 220.299 69.6624 223.974 70.3408C224.687 70.4725 230.351 70.7858 241.587 71.3153C257.714 72.0754 258.181 72.0906 259.358 71.8931C261.519 71.5305 263.285 70.6334 264.864 69.0967C265.85 68.1377 266.639 67.0793 267.156 66.0261C267.55 65.2222 268.04 63.5092 268.146 62.5686C268.305 61.1523 269.724 28.7941 269.666 27.9301C269.58 26.6769 269.265 25.4589 268.706 24.2244C267.058 20.5836 263.789 18.2596 259.869 17.9424C258.802 17.8561 226.917 16.3427 226.817 16.3736C226.783 16.3839 226.588 16.4138 226.384 16.4399ZM193.381 23.5104C195.212 23.9005 197.002 24.792 198.428 26.0238C200.052 27.4263 201.355 30.0989 201.355 32.0264C201.355 32.6114 201.325 32.6964 201.139 32.6438C201.02 32.6101 199.742 32.4516 198.3 32.2913L195.677 32.0001L195.596 31.6158C195.342 30.4097 194.318 29.2359 193.092 28.7449C192.53 28.5199 192.128 28.4634 191.032 28.4558C189.74 28.4467 189.629 28.4668 188.869 28.8516C186.694 29.9526 185.531 32.2707 185.325 35.9187C185.117 39.6017 186.655 42.1495 189.455 42.7572C192.33 43.3812 194.594 42.3155 195.225 40.0408C195.331 39.6613 195.404 39.3408 195.389 39.3285C195.373 39.3164 194.343 39.192 193.1 39.0522C191.857 38.9125 190.819 38.7762 190.792 38.7493C190.73 38.6854 191.194 34.6975 191.274 34.6164C191.345 34.5433 201.075 35.6276 201.231 35.726C201.365 35.8111 200.925 39.6756 200.664 40.7101C199.615 44.8543 196.372 47.6435 192.197 47.9912C188.082 48.3338 184.139 46.8163 181.951 44.0482C180.779 42.5658 179.975 40.6882 179.66 38.7019C178.943 34.1844 180.33 29.1415 183.055 26.3496C185.622 23.7198 189.439 22.6704 193.381 23.5104ZM299.366 27.1427C299.414 28.4167 299.446 29.4716 299.436 29.4871C299.426 29.5025 297.03 29.6082 294.11 29.7222C291.191 29.836 288.782 29.9481 288.758 29.9711C288.734 29.9942 288.755 31.0991 288.805 32.4265L288.895 34.8402L289.467 34.8363C289.781 34.8341 291.985 34.7533 294.364 34.6568C296.743 34.5604 298.711 34.5033 298.737 34.53C298.818 34.6128 298.96 39.0768 298.885 39.1677C298.846 39.2149 297.034 39.3161 294.858 39.3926C292.683 39.4689 290.491 39.5641 289.988 39.604L289.073 39.6767L289.158 42.0951C289.205 43.4252 289.255 44.5256 289.27 44.5404C289.284 44.5554 291.675 44.4783 294.582 44.3691C297.489 44.26 299.89 44.1938 299.917 44.2219C299.943 44.25 300.006 45.307 300.055 46.5708L300.145 48.8687L299.108 48.9438C297.73 49.0437 283.777 49.5499 283.731 49.5018C283.695 49.4633 282.817 25.4206 282.851 25.3912C282.888 25.3586 299.186 24.766 299.23 24.7958C299.256 24.8126 299.317 25.8687 299.366 27.1427ZM34.9251 25.7902C37.7787 25.8954 40.4485 26.0363 40.8579 26.1034C42.5098 26.3738 44.1415 27.072 45.0627 27.9026C47.1538 29.7882 47.4632 33.2481 45.7399 35.4769C45.2072 36.1659 44.0619 36.9104 43.101 37.1924C42.6506 37.3245 42.282 37.467 42.282 37.5089C42.282 37.551 42.6017 37.6573 42.9927 37.7455C46.6612 38.5714 48.4649 42.5972 46.7897 46.2204C45.8049 48.3501 43.7889 49.653 40.8821 50.0383C40.1929 50.1296 28.5717 49.8185 28.4518 49.7055C28.4067 49.663 28.961 31.7216 29.139 27.4649C29.2138 25.6768 29.2281 25.5974 29.4768 25.5981C29.6197 25.5985 32.0714 25.685 34.9251 25.7902ZM90.8433 26.441C95.5294 27.4386 98.6747 31.3501 99.5129 37.2229C99.708 38.5891 99.6032 41.7253 99.3282 42.7535C98.9559 44.1453 97.877 46.2171 97.0349 47.1576C94.7068 49.7573 91.8048 50.9912 88.0758 50.9667C86.5743 50.957 86.1995 50.9105 85.2427 50.6155C83.1856 49.9814 81.817 49.1346 80.4506 47.6508C78.3254 45.3432 77.1943 42.2508 77.0494 38.3528C76.9476 35.6128 77.2697 33.9754 78.3095 31.9484C80.488 27.7017 85.8 25.3674 90.8433 26.441ZM133.561 28.6992C138.952 29.0452 139.653 29.1656 141.398 30.0446C143.26 30.9816 144.642 32.758 145.132 34.8402C145.362 35.8207 145.332 38.1321 145.076 39.145C144.559 41.1887 143.322 42.8719 141.709 43.7263C141.272 43.9573 140.917 44.2033 140.919 44.2729C140.921 44.3425 141.859 46.4507 143.003 48.9576L145.084 53.5157L144.575 53.5509C143.988 53.5916 138.964 53.2729 138.896 53.1907C138.871 53.1606 138.03 51.2841 137.027 49.0209C136.023 46.7577 135.163 44.8625 135.115 44.8094C135.067 44.7563 134.409 44.6766 133.652 44.6322L132.277 44.5516L132.215 44.8553C132.181 45.0225 132.06 46.84 131.946 48.8943C131.832 50.9486 131.704 52.6649 131.661 52.7082C131.586 52.7843 126.4 52.4837 126.139 52.3881C126.052 52.3563 126.246 48.4624 126.733 40.4569C127.13 33.9206 127.475 28.5095 127.5 28.4321C127.528 28.3453 127.774 28.3102 128.143 28.3406C128.471 28.3677 130.909 28.529 133.561 28.6992ZM34.6997 32.1386C34.6552 33.0894 34.6188 34.277 34.6188 34.7776V35.6881L36.3976 35.7742C38.7528 35.8882 39.5824 35.6998 40.3202 34.8831C40.8167 34.3336 40.9617 33.9579 40.9712 33.1958C40.9834 32.2164 40.6435 31.592 39.8204 31.0823C39.1181 30.6475 38.8458 30.6018 36.2138 30.4774L34.7807 30.4098L34.6997 32.1386ZM87.1488 31.4238C84.9578 31.814 83.3872 33.3616 82.9391 35.5721C82.8471 36.0259 82.8162 36.8871 82.8565 37.8789C83.0852 43.5166 85.991 46.7112 89.9335 45.6593C91.5202 45.2359 92.6042 44.3619 93.2233 43.0066C94.0687 41.1562 94.0356 38.3443 93.1358 35.5768C92.1347 32.4972 89.8849 30.9367 87.1488 31.4238ZM236.21 31.6518L238.002 31.7381L237.975 32.2446C237.798 35.5048 237.163 51.0507 237.205 51.0884C237.236 51.116 239.43 51.2376 242.081 51.3583C244.732 51.4793 246.911 51.5869 246.923 51.5976C246.953 51.6259 246.716 56.281 246.682 56.3132C246.625 56.369 231.346 55.6026 231.286 55.5409C231.224 55.4768 232.238 31.8608 232.314 31.6019C232.34 31.5135 232.717 31.4833 233.386 31.5156C233.954 31.543 235.225 31.6043 236.21 31.6518ZM132.881 33.6315C132.881 33.7543 132.795 35.1943 132.69 36.8317C132.584 38.4689 132.524 39.8345 132.555 39.8662C132.586 39.8979 133.394 39.9797 134.35 40.0478C136.643 40.2113 137.598 40.0434 138.424 39.3316C139.655 38.2704 139.749 35.8211 138.603 34.6952C137.732 33.8402 136.981 33.621 134.483 33.4915C133.004 33.4149 132.881 33.4257 132.881 33.6315ZM34.4498 40.1701C34.4124 40.5464 34.3544 41.8313 34.3209 43.0254L34.2601 45.1964L36.1853 45.2889C38.5542 45.4026 39.2804 45.3319 40.1336 44.9042C41.0454 44.4473 41.4178 43.8 41.4141 42.6791C41.4107 41.671 41.1213 40.9778 40.4748 40.4303C39.7573 39.8223 39.039 39.6606 36.6452 39.5682L34.5177 39.4859L34.4498 40.1701Z" fill="white"/>
        <circle cx="14" cy="14" r="12.5" fill="#10B981" stroke="#1E293B" stroke-width="3"/>
        <circle cx="171" cy="65" r="12.5" fill="#3B82F6" stroke="#1E293B" stroke-width="3"/>
        <circle cx="264" cy="14" r="12.5" fill="#8B5CF6" stroke="#1E293B" stroke-width="3"/>
      </svg>
    </div>

    <div id="headerSection">

        <p class="hideOnLarge mobileDate"><span class="bold">{{ $date(date).format('dddd') }}</span>, {{ $date(date).format('MMMM') }} {{ $date(date).format('D') }}</p>

        <div id="logo" ref="logo" @click="shuffleLogo()">
          <svg width="100%" height="100%" viewBox="0 0 321 79" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M174.884 7.11466C170.734 7.83193 167.352 10.9674 166.311 15.0604C166.21 15.4584 166.067 16.2845 165.995 16.8963L165.863 18.0088L166.614 19.5557C167.028 20.4065 167.503 21.6018 167.671 22.2121C168.307 24.5239 168.316 24.106 167.222 42.0508L166.223 58.441L166.549 58.7275C167.188 59.2912 168.558 60.0299 169.665 60.4081C170.719 60.7683 171.847 60.9138 187.378 62.6936C196.501 63.739 204.31 64.5924 204.731 64.59C207.038 64.5767 209.477 63.6357 211.372 62.0268L212.18 61.3406L212.135 60.4668C212.074 59.2963 213.552 26.5661 213.723 25.2929C214.094 22.5356 215.379 19.6891 217.123 17.7588L217.778 17.0345L217.384 16.3137C215.883 13.5651 213.62 11.738 210.754 10.9608C209.852 10.7161 177.34 6.9807 176.28 7.00008C175.829 7.00818 175.201 7.05984 174.884 7.11466ZM100.191 9.23152C99.6191 9.29128 67.5033 14.9394 67.295 15.0169C67.2081 15.0492 67.3847 15.5461 67.7623 16.3319C68.6589 18.1974 68.9972 19.6629 69.0683 21.9889C69.1321 24.0785 68.1962 54.2344 68.0014 56.3645C67.8427 58.1005 67.4 59.6475 66.5702 61.3658L65.8977 62.7585L66.2953 63.4464C66.514 63.8247 67.1379 64.5968 67.6818 65.162C69.2472 66.7889 71.0664 67.8023 73.1619 68.2144C75.1221 68.6 75.1609 68.5947 92.512 65.5398C101.425 63.9706 109.023 62.5984 109.397 62.4902C114.02 61.1536 117.279 56.5344 117.025 51.6798C116.945 50.1553 111.487 17.7022 111.126 16.6028C110.039 13.2981 107.367 10.6422 104.139 9.65871C103.308 9.40523 101.447 9.11516 100.933 9.15884C100.796 9.17062 100.462 9.20328 100.191 9.23152ZM292.634 10.1469C281.305 10.5822 276.403 10.8143 275.699 10.9483C272.436 11.5699 269.619 13.7488 268.122 16.8092L267.745 17.5803L268.676 18.5185C269.907 19.7592 270.675 20.805 271.375 22.1939C272.476 24.3773 272.919 26.2501 272.919 28.7183C272.919 29.8905 271.702 58.0346 271.52 61.0884L271.468 61.9505L272.193 62.5513C273.258 63.4339 274.717 64.1812 276.097 64.55C277.704 64.98 277.581 64.9816 296.156 64.285C307.786 63.8489 311.785 63.6593 312.531 63.5083C316.995 62.6049 320.425 58.8602 320.989 54.2754C321.125 53.1713 319.969 19.742 319.752 18.507C319.399 16.4945 318.427 14.5155 317.067 13.0389C315.094 10.8956 312.649 9.73949 309.786 9.59515C309.122 9.56173 301.403 9.81002 292.634 10.1469ZM22.1781 10.6588C17.2338 11.352 13.3799 15.5949 13.0431 20.7159C12.9323 22.3989 12 51.7146 12 53.5131C12 54.429 12.0603 55.5125 12.134 55.9209C12.9064 60.2009 16.2759 63.6736 20.4819 64.5239C21.8765 64.8057 54.3317 65.9216 55.6529 65.7331C60.047 65.1058 63.6518 61.7033 64.5889 57.2983C64.867 55.991 65.9746 22.6894 65.7913 21.1441C65.6288 19.7738 65.0911 18.1536 64.4079 16.9753C63.4678 15.3544 61.6383 13.6082 59.9947 12.7628C59.21 12.3591 57.5379 11.8566 56.6196 11.7483C56.2457 11.7043 49.2654 11.4432 41.1078 11.1681C32.9502 10.8931 25.5249 10.642 24.6072 10.6101C23.6895 10.5783 22.5963 10.6002 22.1781 10.6588ZM120.249 13.4473C118.342 13.9276 116.723 14.8324 115.356 16.1811L114.603 16.9243L117.385 33.3208C119.934 48.3395 120.173 49.8768 120.234 51.6165C120.33 54.3439 119.963 56.118 118.82 58.4537C117.848 60.4381 116.202 62.3938 114.416 63.6831L113.441 64.3873L113.798 64.6923C115.179 65.8711 116.944 66.729 118.669 67.0591C120.199 67.3519 151.335 69.3231 153.028 69.2342C154.592 69.1521 155.452 68.9266 156.921 68.2125C159.908 66.7608 162.085 63.9044 162.682 60.6524C163.01 58.8628 164.948 27.3044 164.849 25.3441C164.771 23.7722 164.551 22.875 163.89 21.4257C162.455 18.276 159.657 16.0399 156.361 15.409C155.191 15.1848 124.472 13.183 122.437 13.1983C121.671 13.204 120.839 13.2987 120.249 13.4473ZM226.384 16.4399C221.839 17.0209 218.283 20.155 217.158 24.5727C216.944 25.4143 216.815 27.6906 216.123 42.841C215.257 61.7926 215.263 61.1629 215.934 63.2017C217.136 66.8533 220.299 69.6624 223.974 70.3408C224.687 70.4725 230.351 70.7858 241.587 71.3153C257.714 72.0754 258.181 72.0906 259.358 71.8931C261.519 71.5305 263.285 70.6334 264.864 69.0967C265.85 68.1377 266.639 67.0793 267.156 66.0261C267.55 65.2222 268.04 63.5092 268.146 62.5686C268.305 61.1523 269.724 28.7941 269.666 27.9301C269.58 26.6769 269.265 25.4589 268.706 24.2244C267.058 20.5836 263.789 18.2596 259.869 17.9424C258.802 17.8561 226.917 16.3427 226.817 16.3736C226.783 16.3839 226.588 16.4138 226.384 16.4399ZM193.381 23.5104C195.212 23.9005 197.002 24.792 198.428 26.0238C200.052 27.4263 201.355 30.0989 201.355 32.0264C201.355 32.6114 201.325 32.6964 201.139 32.6438C201.02 32.6101 199.742 32.4516 198.3 32.2913L195.677 32.0001L195.596 31.6158C195.342 30.4097 194.318 29.2359 193.092 28.7449C192.53 28.5199 192.128 28.4634 191.032 28.4558C189.74 28.4467 189.629 28.4668 188.869 28.8516C186.694 29.9526 185.531 32.2707 185.325 35.9187C185.117 39.6017 186.655 42.1495 189.455 42.7572C192.33 43.3812 194.594 42.3155 195.225 40.0408C195.331 39.6613 195.404 39.3408 195.389 39.3285C195.373 39.3164 194.343 39.192 193.1 39.0522C191.857 38.9125 190.819 38.7762 190.792 38.7493C190.73 38.6854 191.194 34.6975 191.274 34.6164C191.345 34.5433 201.075 35.6276 201.231 35.726C201.365 35.8111 200.925 39.6756 200.664 40.7101C199.615 44.8543 196.372 47.6435 192.197 47.9912C188.082 48.3338 184.139 46.8163 181.951 44.0482C180.779 42.5658 179.975 40.6882 179.66 38.7019C178.943 34.1844 180.33 29.1415 183.055 26.3496C185.622 23.7198 189.439 22.6704 193.381 23.5104ZM299.366 27.1427C299.414 28.4167 299.446 29.4716 299.436 29.4871C299.426 29.5025 297.03 29.6082 294.11 29.7222C291.191 29.836 288.782 29.9481 288.758 29.9711C288.734 29.9942 288.755 31.0991 288.805 32.4265L288.895 34.8402L289.467 34.8363C289.781 34.8341 291.985 34.7533 294.364 34.6568C296.743 34.5604 298.711 34.5033 298.737 34.53C298.818 34.6128 298.96 39.0768 298.885 39.1677C298.846 39.2149 297.034 39.3161 294.858 39.3926C292.683 39.4689 290.491 39.5641 289.988 39.604L289.073 39.6767L289.158 42.0951C289.205 43.4252 289.255 44.5256 289.27 44.5404C289.284 44.5554 291.675 44.4783 294.582 44.3691C297.489 44.26 299.89 44.1938 299.917 44.2219C299.943 44.25 300.006 45.307 300.055 46.5708L300.145 48.8687L299.108 48.9438C297.73 49.0437 283.777 49.5499 283.731 49.5018C283.695 49.4633 282.817 25.4206 282.851 25.3912C282.888 25.3586 299.186 24.766 299.23 24.7958C299.256 24.8126 299.317 25.8687 299.366 27.1427ZM34.9251 25.7902C37.7787 25.8954 40.4485 26.0363 40.8579 26.1034C42.5098 26.3738 44.1415 27.072 45.0627 27.9026C47.1538 29.7882 47.4632 33.2481 45.7399 35.4769C45.2072 36.1659 44.0619 36.9104 43.101 37.1924C42.6506 37.3245 42.282 37.467 42.282 37.5089C42.282 37.551 42.6017 37.6573 42.9927 37.7455C46.6612 38.5714 48.4649 42.5972 46.7897 46.2204C45.8049 48.3501 43.7889 49.653 40.8821 50.0383C40.1929 50.1296 28.5717 49.8185 28.4518 49.7055C28.4067 49.663 28.961 31.7216 29.139 27.4649C29.2138 25.6768 29.2281 25.5974 29.4768 25.5981C29.6197 25.5985 32.0714 25.685 34.9251 25.7902ZM90.8433 26.441C95.5294 27.4386 98.6747 31.3501 99.5129 37.2229C99.708 38.5891 99.6032 41.7253 99.3282 42.7535C98.9559 44.1453 97.877 46.2171 97.0349 47.1576C94.7068 49.7573 91.8048 50.9912 88.0758 50.9667C86.5743 50.957 86.1995 50.9105 85.2427 50.6155C83.1856 49.9814 81.817 49.1346 80.4506 47.6508C78.3254 45.3432 77.1943 42.2508 77.0494 38.3528C76.9476 35.6128 77.2697 33.9754 78.3095 31.9484C80.488 27.7017 85.8 25.3674 90.8433 26.441ZM133.561 28.6992C138.952 29.0452 139.653 29.1656 141.398 30.0446C143.26 30.9816 144.642 32.758 145.132 34.8402C145.362 35.8207 145.332 38.1321 145.076 39.145C144.559 41.1887 143.322 42.8719 141.709 43.7263C141.272 43.9573 140.917 44.2033 140.919 44.2729C140.921 44.3425 141.859 46.4507 143.003 48.9576L145.084 53.5157L144.575 53.5509C143.988 53.5916 138.964 53.2729 138.896 53.1907C138.871 53.1606 138.03 51.2841 137.027 49.0209C136.023 46.7577 135.163 44.8625 135.115 44.8094C135.067 44.7563 134.409 44.6766 133.652 44.6322L132.277 44.5516L132.215 44.8553C132.181 45.0225 132.06 46.84 131.946 48.8943C131.832 50.9486 131.704 52.6649 131.661 52.7082C131.586 52.7843 126.4 52.4837 126.139 52.3881C126.052 52.3563 126.246 48.4624 126.733 40.4569C127.13 33.9206 127.475 28.5095 127.5 28.4321C127.528 28.3453 127.774 28.3102 128.143 28.3406C128.471 28.3677 130.909 28.529 133.561 28.6992ZM34.6997 32.1386C34.6552 33.0894 34.6188 34.277 34.6188 34.7776V35.6881L36.3976 35.7742C38.7528 35.8882 39.5824 35.6998 40.3202 34.8831C40.8167 34.3336 40.9617 33.9579 40.9712 33.1958C40.9834 32.2164 40.6435 31.592 39.8204 31.0823C39.1181 30.6475 38.8458 30.6018 36.2138 30.4774L34.7807 30.4098L34.6997 32.1386ZM87.1488 31.4238C84.9578 31.814 83.3872 33.3616 82.9391 35.5721C82.8471 36.0259 82.8162 36.8871 82.8565 37.8789C83.0852 43.5166 85.991 46.7112 89.9335 45.6593C91.5202 45.2359 92.6042 44.3619 93.2233 43.0066C94.0687 41.1562 94.0356 38.3443 93.1358 35.5768C92.1347 32.4972 89.8849 30.9367 87.1488 31.4238ZM236.21 31.6518L238.002 31.7381L237.975 32.2446C237.798 35.5048 237.163 51.0507 237.205 51.0884C237.236 51.116 239.43 51.2376 242.081 51.3583C244.732 51.4793 246.911 51.5869 246.923 51.5976C246.953 51.6259 246.716 56.281 246.682 56.3132C246.625 56.369 231.346 55.6026 231.286 55.5409C231.224 55.4768 232.238 31.8608 232.314 31.6019C232.34 31.5135 232.717 31.4833 233.386 31.5156C233.954 31.543 235.225 31.6043 236.21 31.6518ZM132.881 33.6315C132.881 33.7543 132.795 35.1943 132.69 36.8317C132.584 38.4689 132.524 39.8345 132.555 39.8662C132.586 39.8979 133.394 39.9797 134.35 40.0478C136.643 40.2113 137.598 40.0434 138.424 39.3316C139.655 38.2704 139.749 35.8211 138.603 34.6952C137.732 33.8402 136.981 33.621 134.483 33.4915C133.004 33.4149 132.881 33.4257 132.881 33.6315ZM34.4498 40.1701C34.4124 40.5464 34.3544 41.8313 34.3209 43.0254L34.2601 45.1964L36.1853 45.2889C38.5542 45.4026 39.2804 45.3319 40.1336 44.9042C41.0454 44.4473 41.4178 43.8 41.4141 42.6791C41.4107 41.671 41.1213 40.9778 40.4748 40.4303C39.7573 39.8223 39.039 39.6606 36.6452 39.5682L34.5177 39.4859L34.4498 40.1701Z" fill="white"/>
            <circle ref="lgc1" cx="14" cy="14" r="12.5" fill="#10B981" stroke="#1E293B" stroke-width="3"/>
            <circle ref="lgc2" cx="171" cy="65" r="12.5" fill="#3B82F6" stroke="#1E293B" stroke-width="3"/>
            <circle ref="lgc3" cx="264" cy="14" r="12.5" fill="#8B5CF6" stroke="#1E293B" stroke-width="3"/>
          </svg>
        </div>

        <div id="infoRow" class="infoRow">
          <p class="hideOnSmall"><span class="bold">{{ $date(date).format('dddd') }}</span>, {{ $date(date).format('MMMM') }} {{ $date(date).format('D') }}</p>
          <!-- <p class="separator">|</p>
          <p>Today's goal is <span class="bold">{{todaysBoard.totalGoal}} words</span></p> -->
          <p class="separator hideOnSmall">|</p>
          <a @click="openInstructions()" class="link yellow">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_81_2503)">
              <path d="M7.99967 15.1668C11.6816 15.1668 14.6663 12.1821 14.6663 8.50016C14.6663 4.81826 11.6816 1.8335 7.99967 1.8335C4.31778 1.8335 1.33301 4.81826 1.33301 8.50016C1.33301 12.1821 4.31778 15.1668 7.99967 15.1668Z" fill="#FDE047" stroke="#FDE047" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.05957 6.49989C6.21631 6.05434 6.52567 5.67863 6.93287 5.43931C7.34007 5.2 7.81883 5.11252 8.28435 5.19237C8.74987 5.27222 9.17211 5.51424 9.47629 5.87558C9.78046 6.23691 9.94694 6.69424 9.94624 7.16656C9.94624 8.49989 7.94624 9.16656 7.94624 9.16656" stroke="#1E293B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8 11.8335H8.00667" stroke="#1E293B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
              <clipPath id="clip0_81_2503">
              <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
              </clipPath>
              </defs>
            </svg>

            How To Play
          </a>
          <p class="separator">|</p>
          <a href="https://ko-fi.com/dnlrj" target="_blank" class="link green">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5.8335H12.6667C13.3739 5.8335 14.0522 6.11445 14.5523 6.61454C15.0524 7.11464 15.3333 7.79292 15.3333 8.50016C15.3333 9.20741 15.0524 9.88568 14.5523 10.3858C14.0522 10.8859 13.3739 11.1668 12.6667 11.1668H12" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.33301 5.8335H11.9997V11.8335C11.9997 12.5407 11.7187 13.219 11.2186 13.7191C10.7185 14.2192 10.0403 14.5002 9.33301 14.5002H3.99967C3.29243 14.5002 2.61415 14.2192 2.11406 13.7191C1.61396 13.219 1.33301 12.5407 1.33301 11.8335V5.8335Z" fill="#10B981" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4 1.1665V3.1665" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.66699 1.1665V3.1665" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9.33301 1.1665V3.1665" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            Support Borgle
          </a>
          <p class="separator">|</p>
          <a @click="openAbout()" class="link blue">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_109_2254)">
              <path d="M7.99967 15.1668C11.6816 15.1668 14.6663 12.1821 14.6663 8.50016C14.6663 4.81826 11.6816 1.8335 7.99967 1.8335C4.31778 1.8335 1.33301 4.81826 1.33301 8.50016C1.33301 12.1821 4.31778 15.1668 7.99967 15.1668Z" fill="#3B82F6" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8 11.1667V8.5" stroke="#1E293B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8 5.8335H8.00667" stroke="#1E293B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
              <clipPath id="clip0_109_2254">
              <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
              </clipPath>
              </defs>
            </svg>

            About
          </a>
        </div>

        <!-- <div v-if="((!compressedLayout) && (windowWidth < 780))" id="mobileAdSection" class="bglAdSection hideOnLarge">
          <div class="ad">
            <div id='borgle-xyz_320x50'>
                <script type='application/javascript'>
                  aiptag.cmd.display.push(function() { aipDisplayTag.display('borgle-xyz_320x50'); });
                </script>
              </div>
          </div>
        </div> -->

    </div>

    <div id="mainSection">

      <div id="boardSection">

          <div id="board" ref="board" @mousedown="boardClicked()">

            <div
            v-for="(row,x) in board"
            :key="x+row"
            class="row">

              <Tile
              v-for="(tile, i) in row"
              :key="i+tile"
              :letter="tile"
              :debug="false"
              :tileIndex="(x*5)+i"
              :id="`row${x+1}tile${i+1}`"
              :hideLetters="hideLetters"
              :highlighted="highlightedTiles.has((x*5)+i)"
              :compressed="compressedLayout"/>
            </div>

          </div>
      </div>

      <div id="sidePanel">

        <div id="inputSection">
          <div id="comboInput">
            <button
            type="button"
            id="psuedoButton"
            class="button primary hideOnLarge"
            :class="{ hidden: ((this.phase != 1) || (this.startBtnHidden))}">
                Start Round
            </button>

            <input
            v-if="(this.phase != 3)"
            type="text"
            id="wordInput"
            ref="wordInput"
            class="button primary"
            autocomplete="off"
            :placeholder="this.placeholderText"
            :class="{ buttonMode: this.phase === 1, inputMode: this.phase === 2, hidden: ((this.startBtnHidden) && (this.phase == 1))}"
            @click="inputClicked"
            @input="highlightLettersOnBoard">
          </div>

          <button
          v-if="this.phase === 3"
          type="button"
          id="shareResults"
          class="button primary"
          :disabled="this.phase != 3"
          :class="{ hidden: this.phase != 3 }"
          @click="shareResults()">
            Share Results
          </button>

        </div>

        <div id="gameInfo">

          <button
            v-if="!endRoundClicked"
            type="button"
            id="endRoundBtnCompressed"
            class="button tertiary"
            v-bind:disabled="this.phase != 2"
            v-bind:class="{ hidden: ((this.phase != 2) || (!this.compressedLayout)) }"
            @click="endRoundConfirm()">
              {{endRoundMsg}}
          </button>

          <button
            v-else
            type="button"
            id="endRoundBtnCompressed"
            class="button secondary"
            v-bind:disabled="this.phase != 2"
            v-bind:class="{ hidden: ((this.phase != 2) || (!this.compressedLayout)) }"
            @click="roundEnd()">
              {{endRoundMsg}}
          </button>

          <div
          v-if="this.phase != 3"
          id="timerSection"
          class="infoBadge"
          :class="{flashTimer: this.flashTimer}">

            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 6V12L16 14"  stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <div id="countdown">

              <h1 v-if="phase === 1">{{roundTime / 1000}}</h1>

              <h1 v-else-if="phase === 2">
                  <vue-countdown ref="roundCounter" :time="roundTime" @end="roundEnd" @progress="checkTimer" v-slot="{ totalSeconds }">{{totalSeconds}}</vue-countdown>
              </h1>

              <h1 v-else>0</h1>

            </div>
          </div>

          <div
          v-if="this.phase != 3"
          id="scoreSection"
          class="infoBadge">

            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z"  stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <h1><span class="reg">{{userData.results.score}} of </span>{{todaysBoard.totalGoal}}</h1>

          </div>

        </div>

        <div
        id="newBoardCountdown"
        class="infoBadge"
        :class="{hiddenMax: this.phase != 3}">

          <div class="infoBadgeMain">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 21C16.9183 21 20.5 17.4183 20.5 13C20.5 8.58172 16.9183 5 12.5 5C8.08172 5 4.5 8.58172 4.5 13C4.5 17.4183 8.08172 21 12.5 21Z" stroke="#94A3B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12.5 9V13L14.5 15" stroke="#94A3B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.5 3L2.5 6" stroke="#94A3B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M22.5 6L19.5 3" stroke="#94A3B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.5 19L4.5 21" stroke="#94A3B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18.5 19L20.5 21" stroke="#94A3B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <h1>
              <vue-countdown :time="this.msLeft" :transform="transformSlotProps" v-slot="{ hours, minutes, seconds }">
                {{ hours }}:{{ minutes }}:{{ seconds }} <span class="grey">left</span>
              </vue-countdown>
            </h1>
          </div>

          <h2>Check back soon for a new board!</h2>

        </div>

        <transition-group
        name="submitted-words"
        id="submittedWords"
        ref="submittedWords"
        :class="{'lockedIn':saveDisabled}"
        :style="{maxHeight: this.phase === 2 ? '210px' : '260px'}"
        tag="div">
          <SubmittedWord
          v-for="(wordObj, i) in userData.submittedWords"
          :key="i+wordObj.word"
          :word="wordObj.word"
          :difficulty="wordObj.difficulty"
          :roundActive="phase === 2"/>
        </transition-group>

        <button
          v-if="!endRoundClicked"
          type="button"
          id="endRoundBtn"
          class="button tertiary"
          v-bind:disabled="this.phase != 2"
          v-bind:class="{ hidden: ((this.phase != 2) || (this.compressedLayout)) }"
          @click="endRoundConfirm()">
            {{endRoundMsg}}
        </button>

        <button
          v-else
          type="button"
          id="endRoundBtn"
          class="button secondary"
          v-bind:disabled="this.phase != 2"
          v-bind:class="{ hidden: ((this.phase != 2) || (this.compressedLayout)) }"
          @click="roundEnd()">
            {{endRoundMsg}}
        </button>

      </div>

    </div>

    <!-- <div v-if="windowWidth >= 780" id="desktopAdSection" class="bglAdSection">
      <div class="ad">
        <div id='borgle-xyz_728x90'>
          <script type='application/javascript'>
            aiptag.cmd.display.push(function() { aipDisplayTag.display('borgle-xyz_728x90'); });
          </script>
        </div>
      </div>
    </div> -->

  </div>
</template>

<script>

import Tile from './Tile.vue'
import SubmittedWord from './SubmittedWord.vue'
import SimplifiedWord from './SimplifiedWord.vue'
import VueCountdown from '@chenfengyuan/vue-countdown'
import LottieAnimation from 'lottie-web-vue'
import dailyBoardData from '../assets/boardData.json'
import { isMobileOnly, isMobile } from 'mobile-device-detect'
import tinykeys from 'tinykeys'

export default {
  name: 'Game',
  components: { Tile, SubmittedWord, SimplifiedWord, VueCountdown, LottieAnimation },
  data () {
    return {
      version: 2.1,
      isMobile: false,
      windowSize: 0,
      roundTime: 180000,
      phase: null,
      startBtnHidden: true,
      saveDisabled: true,
      flashTimer: false,
      subdueColors: false,
      clipboardTooltip: false,
      compressedLayout: false,
      logoFills: ['#10B981', '#3B82F6', '#8B5CF6'],
      placeholderText: 'Start Round',
      allDice: ['aaafrs', 'aaeeee', 'aafirs', 'adennn', 'aeeeem', 'aeegmu', 'aegmnn', 'afirsy', 'bbjkxz', 'ccenst', 'eiilst', 'ceipst', 'ddhnot', 'dhhlor', 'dhhnow', 'dhlnor', 'eiiitt', 'eilpst', 'emottt', 'ensssu', 'gorrvw', 'iprsyy', 'nootuw', 'ooottu', '1234567'],
      board: [[' ', ' ', ' ', ' ', ' '], [' ', ' ', ' ', ' ', ' '], [' ', ' ', ' ', ' ', ' '], [' ', ' ', ' ', ' ', ' '], [' ', ' ', ' ', ' ', ' ']],
      rawBoardLetters: [],
      specialTile: {
        code: null,
        value: null
      },
      highlightedTiles: new Set(),
      hideLetters: null,
      averageWords: 0,
      dailyBoardData: dailyBoardData,
      todaysBoard: {},
      date: new Date(),
      msLeft: 0,
      endRoundMsg: 'End Round Now',
      endRoundClicked: false,
      streakEligible: false,
      longestWord: '',
      longestWordFiltered: '',
      userData: {
        lastDayPlayed: 0,
        historicResults: [],
        daysPlayed: 0,
        totalWordsFound: 0,
        streak: 1,
        totalWins: 0,
        submittedWords: [],
        results: {
          score: 0,
          easyScore: 0,
          hardScore: 0,
          impossibleScore: 0
        }
      }
    }
  },
  created () {

  },
  watch: {
    userData: {
      handler () {
        localStorage.userData = JSON.stringify(this.userData)
      },
      deep: true
    }
  },
  methods: {
    beforeModalOpen () {
      this.subdueColors = true
      if (this.phase === 2) {
        this.$refs.roundCounter.abort()
        this.hideLetters = true
      }
    },

    beforeModalClose () {
      this.subdueColors = false
      if (this.phase === 2) {
        this.$refs.roundCounter.start()
        this.hideLetters = false
      }
    },

    checkTimer (data) {
      if (data.totalSeconds === 10) {
        this.flashTimer = true
      }
    },

    transformSlotProps (props) {
      const formattedProps = {}

      Object.entries(props).forEach(([key, value]) => {
        formattedProps[key] = value < 10 ? `0${value}` : String(value)
      })

      return formattedProps
    },

    boardClicked () {
      if (this.phase === 2) {
        const delay = 1000
        let preventDupeClick = false
        if (!preventDupeClick) {
          // this.placeholderText = 'Type '
          this.animateInput('yellow', 1000)
          this.animateInput('vibrate', 500)
          preventDupeClick = true

          setTimeout(() => {
            this.focusInput()
            preventDupeClick = false
          }, delay)
        }
      }
    },

    endRoundConfirm () {
      this.endRoundClicked = true
      this.endRoundMsg = 'Are you sure?'
      if (isMobile) { this.endRoundMsg = 'Sure?' }

      setTimeout(() => {
        this.endRoundClicked = false
        this.endRoundMsg = 'End Round Now'
        if (isMobile) { this.endRoundMsg = 'End' }
      }, 5000)
    },

    handleHistoricResults () {
      if (this.userData.historicResults[0] === undefined) { // User hasn't played yet
        this.userData.historicResults.push({
          day: this.todaysBoard.day,
          submittedWords: this.userData.submittedWords,
          results: this.userData.results
        })
      } else {
        if (this.userData.historicResults[this.userData.historicResults.length - 1].day !== this.todaysBoard.day) { // No entry for today yet
          this.userData.historicResults.push({
            day: this.todaysBoard.day,
            submittedWords: this.userData.submittedWords,
            results: this.userData.results
          })
        } else { // Entry exists for today already
          this.userData.historicResults[this.userData.historicResults.length - 1].submittedWords = this.userData.submittedWords
          this.userData.historicResults[this.userData.historicResults.length - 1].results = this.userData.results
        }
      }
    },

    calcPercentages () {
      this.userData.results.totalGoal = this.todaysBoard.totalGoal
      this.userData.results.goalPercentage = Math.round(this.userData.results.score / this.userData.results.totalGoal * 100)
      this.userData.results.easyPercentage = Math.round(this.userData.results.easyScore / this.todaysBoard.easyWords.length * 100)
      this.userData.results.hardPercentage = Math.round(this.userData.results.hardScore / this.todaysBoard.hardWords.length * 100)
      this.userData.results.impossiblePercentage = Math.round(this.userData.results.impossibleScore / this.todaysBoard.impossibleWords.length * 100)

      if (this.userData.results.goalPercentage < 100) { // User came short of goal
        this.userData.results.won = false
      } else { // User met or exceeded goal
        this.userData.results.won = true
      }
    },

    isHighlighted (i) {
      console.log(i)
    },

    focusInput () {
      if (!isMobile) {
        this.$refs.wordInput.focus()
      } else {
        // this.$refs.wordInput.click()
        // this.$refs.wordInput.focus()
        // this.$refs.wordInput.setSelectionRange(0, 9999)
      }
    },

    inputClicked () {
      if (this.phase === 1) {
        this.roundStart()
        this.placeholderText = 'Type a word here and hit enter'
      }

      if ((this.phase === 2) && (this.compressedLayout)) {
        this.scrollToTop()
      }
    },

    shuffleLogo () {
      function shuffle (array) {
        let currentIndex = array.length; let randomIndex

        // While there remain elements to shuffle...
        while (currentIndex !== 0) {
          // Pick a remaining element...
          randomIndex = Math.floor(Math.random() * currentIndex)
          currentIndex--;

          // And swap it with the current element.
          [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]]
        }

        return array
      }

      this.logoFills = shuffle(this.logoFills)
      this.$refs.lgc1.style.fill = this.logoFills[0]
      this.$refs.lgc2.style.fill = this.logoFills[1]
      this.$refs.lgc3.style.fill = this.logoFills[2]
      this.animateLogo('jello', 500)
    },

    scrollToTop () {
      const scrollToTop = setInterval(() => {
        window.scrollTo(0, 0)
      }, 10)

      setTimeout(() => {
        clearInterval(scrollToTop)
      }, 200)
    },

    findLongestWord () {
      if (this.userData.submittedWords.length !== 0) {
        var longestString = this.userData.submittedWords.reduce(
          function (a, b) {
            return a.word.length > b.word.length ? a : b
          })

        this.longestWord = longestString.word

        let newString = this.longestWord[0] // Get first letter
        for (let i = 1; i < longestString.word.length; i++) { // Start count at 1 to skip first letter, since we're exposing that
          newString = `${newString}•`
        }

        this.longestWordFiltered = newString
      } else {
        this.longestWord = null
        this.longestWordFiltered = null
      }
    },

    roundStart: function () {
      // Set focus to input
      setTimeout(() => { this.focusInput() }, 10)

      // Add to streak
      if (this.streakEligible) { this.userData.streak++ }
      this.userData.lastDayPlayed = this.todaysBoard.day
      this.userData.daysPlayed++

      // Handle state saving
      this.phase = 2
      localStorage.phase = 3
      this.startBtnHidden = true
      this.generateDisabled = true
      this.hideLetters = false
      this.userData.submittedWords = []

      // Handle board animation
      this.animateBoard('wobble-hor-bottom', 650)

      // Handle compressed layout switch
      if (isMobile) {
        this.compressedLayout = true
        this.endRoundMsg = 'End'

        this.scrollToTop()
      }
    },

    roundEnd: function () {
      // Kill timer
      this.flashTimer = false

      // Remove highlight styling
      this.highlightedTiles = new Set()

      // Handle state saving
      this.phase = 3
      localStorage.phase = 3
      this.saveDisabled = false

      // Update wins
      if (this.userData.results.won) { this.userData.totalWins++ }

      // Handle compressed layout switch
      if (isMobile) { this.compressedLayout = false }

      // Bring up results share card
      setTimeout(() => {
        this.shareResults()
      }, 0)

      // Alphabetize submitted words
      // function sortByKey (array, key) {
      //   return array.sort(function (a, b) {
      //     var x = a[key]; var y = b[key]
      //     return ((x < y) ? -1 : ((x > y) ? 1 : 0))
      //   })
      // }

      // sortByKey(this.userData.submittedWords, 'word')
    },

    closeModal () {
      this.$modal.hide('results')
      this.$modal.hide('instructions')
      this.$modal.hide('about')
      this.$modal.hide('warning')
    },

    animateBoard (cssClass, duration) {
      const board = this.$refs.board
      /* eslint-disable */
      void board.offsetWidth
      /* eslint-enable */
      board.classList.add(cssClass)
      setTimeout(() => { board.classList.remove(cssClass) }, duration)
    },

    animateInput (cssClass, duration) {
      const input = this.$refs.wordInput
      /* eslint-disable */
      void input.offsetWidth
      /* eslint-enable */
      input.classList.add(cssClass)
      setTimeout(() => { input.classList.remove(cssClass) }, duration)
    },

    animateLogo (cssClass, duration) {
      const logo = this.$refs.logo
      /* eslint-disable */
      void logo.offsetWidth
      /* eslint-enable */
      logo.classList.add(cssClass)
      setTimeout(() => { logo.classList.remove(cssClass) }, duration)
    },

    shareResults () {
      this.averageWords = parseInt(this.userData.totalWordsFound / this.userData.daysPlayed)
      if (isNaN(this.averageWords)) { this.averageWords = 0 }

      this.findLongestWord()

      this.$modal.show('results')
    },

    shareTextResults () {
      let wordsFound = false
      // Initialize string
      let resultsString = `Borgle ${this.$date(this.date).format('M')}/${this.$date(this.date).format('D')}/${this.$date(this.date).format('YY')}`

      // Add trophy or just a new line
      if (this.userData.results.won) {
        resultsString = `${resultsString} 🏆
`
      } else {
        resultsString = `${resultsString}
`
      }

      // Add total score
      resultsString = `${resultsString}${this.userData.results.score} words found (${this.userData.results.goalPercentage}% of goal)
        
`

      // Add words
      this.userData.submittedWords.forEach((word, i) => {
        wordsFound = true

        // Make new line if 10 items have been reached
        if ((i % 10 === 0) && (i !== 0)) {
          resultsString = `${resultsString}
`
        }

        // Add corresponding emoji
        if (word.difficulty === 'easy') { resultsString = `${resultsString}🟢` }
        if (word.difficulty === 'hard') { resultsString = `${resultsString}🔵` }
        if (word.difficulty === 'impossible') { resultsString = `${resultsString}🟣` }
      })

      if (wordsFound) {
        resultsString = `${resultsString}

`
      }

      // Close string
      resultsString = `${resultsString}https://borgle.xyz`

      console.log(resultsString)

      if (isMobile) {
        navigator.share({ text: resultsString })
      } else {
        navigator.clipboard.writeText(resultsString)

        this.clipboardTooltip = true
        setTimeout(() => { this.clipboardTooltip = false }, 1500)
      }
    },

    updateSpecialTile () {
      this.specialTile.code = this.rawBoardLetters.join().match(/\d+/)[0]

      switch (this.specialTile.code) {
        case '1': this.specialTile.value = 'qu'; break
        case '2': this.specialTile.value = 'in'; break
        case '3': this.specialTile.value = 'th'; break
        case '4': this.specialTile.value = 'er'; break
        case '5': this.specialTile.value = 'he'; break
        case '6': this.specialTile.value = 'an'; break
        case '7': this.specialTile.value = '_'; break
      }

      console.log(this.specialTile)
    },

    checkLastPlayed () {
      if (this.userData.lastDayPlayed !== this.todaysBoard.day) { // User has not played today
        if (this.todaysBoard.day === this.userData.lastDayPlayed + 1) {
          this.streakEligible = true
        } else if ((this.todaysBoard.day === 1) && (this.userData.lastDayPlayed > 364)) {
          this.streakEligible = true
        } else {
          this.userData.streak = 1
        }

        this.phase = 1
        localStorage.phase = 1

        this.userData.submittedWords = []

        this.userData.results = {
          score: 0,
          easyScore: 0,
          hardScore: 0,
          impossibleScore: 0
        }
        this.calcPercentages()
        this.handleHistoricResults()

        this.hideLetters = true
      }
    },

    loadBoard (str) {
      console.log(str)
      const x = atob(str)
      const y = JSON.parse(x)
      this.board = y
      this.generateDisabled = true

      this.rawBoardLetters = []
      this.board.forEach(row => {
        row.forEach(letter => {
          this.rawBoardLetters.push(letter)
        })
      })

      this.updateSpecialTile()
      this.checkLastPlayed()
    },

    handleBoardLoad () {
      this.loadBoard(this.todaysBoard.board)
      if (this.todaysBoard.totalGoal > 25) { this.todaysBoard.totalGoal = 25 }
      this.todaysBoard.easyWordCount = this.todaysBoard.easyWords.length
      this.todaysBoard.hardWordCount = this.todaysBoard.hardWords.length
      this.todaysBoard.impossibleWordCount = this.todaysBoard.impossibleWords.length
    },

    handleSubmittedWord (word) {
      // First check if the submitted word is a duplicate of an already accepted word
      this.highlightedTiles = new Set()
      const dupeFound = []
      this.userData.submittedWords.forEach(existingWord => {
        if (word === existingWord.word) {
          dupeFound.push(word)
          console.log(`you've already submitted ${word}`)
        }
      })

      const tempWordObj = {}

      const self = this

      function handleValidWord (word, difficulty) {
        console.log(`${word} | ${difficulty}`)
        tempWordObj.word = word
        tempWordObj.difficulty = difficulty
        self.userData.results.score++
        self.userData.totalWordsFound++
        self.userData.submittedWords.push(tempWordObj) // Add word object to submitted list
      }

      if (dupeFound.length < 1) { // If no duplicate word is found
        // Check if word is on any wordlist
        if (this.todaysBoard.easyWords.indexOf(word) !== -1) {
          this.userData.results.easyScore++
          handleValidWord(word, 'easy')
          this.animateInput('green', 400)
          this.animateInput('jello', 500)
        } else if (this.todaysBoard.hardWords.indexOf(word) !== -1) {
          this.userData.results.hardScore++
          handleValidWord(word, 'hard')
          this.animateInput('blue', 400)
          this.animateInput('jello', 500)
        } else if (this.todaysBoard.impossibleWords.indexOf(word) !== -1) {
          this.userData.results.impossibleScore++
          handleValidWord(word, 'impossible')
          this.animateInput('purple', 400)
          this.animateInput('jello', 500)
        } else {
          console.log(`${word} | not a valid word`)
          this.animateInput('red', 400)
          this.animateInput('shake-bottom', 500)
        }
      }

      // THIS VERSION IS FOR COMPRESSED ONLY
      // Scroll to bottom of div if too many words have been submitted
      // THIS VERSION IS FOR COMPRESSED ONLY
      // if (this.compressedLayout) {
      //   const submittedWordsBlock = this.$el.querySelector('#submittedWords')
      //   setTimeout(() => {
      //     submittedWordsBlock.scrollTop = submittedWordsBlock.scrollHeight
      //   }, 50)
      // }

      // Scroll to bottom of div if too many words have been submitted
      const submittedWordsBlock = this.$el.querySelector('#submittedWords')
      setTimeout(() => {
        submittedWordsBlock.scrollTop = submittedWordsBlock.scrollHeight
      }, 50)

      this.calcPercentages()
      this.handleHistoricResults()
    },

    getSurroundingTiles (pos) {
      let surroundingTiles = []

      switch (pos) {
        case 0: surroundingTiles = [1, 5, 6]; break
        case 1: surroundingTiles = [0, 2, 5, 6, 7]; break
        case 2: surroundingTiles = [1, 3, 6, 7, 8]; break
        case 3: surroundingTiles = [2, 4, 7, 8, 9]; break
        case 4: surroundingTiles = [3, 8, 9]; break
        case 5: surroundingTiles = [0, 1, 6, 10, 11]; break
        case 6: surroundingTiles = [0, 1, 2, 5, 7, 10, 11, 12]; break
        case 7: surroundingTiles = [1, 2, 3, 6, 8, 11, 12, 13]; break
        case 8: surroundingTiles = [2, 3, 4, 7, 9, 12, 13, 14]; break
        case 9: surroundingTiles = [3, 4, 8, 13, 14]; break
        case 10: surroundingTiles = [5, 6, 11, 15, 16]; break
        case 11: surroundingTiles = [5, 6, 7, 10, 12, 15, 16, 17]; break
        case 12: surroundingTiles = [6, 7, 8, 11, 13, 16, 17, 18]; break
        case 13: surroundingTiles = [7, 8, 9, 12, 14, 17, 18, 19]; break
        case 14: surroundingTiles = [8, 9, 13, 18, 19]; break
        case 15: surroundingTiles = [10, 11, 16, 20, 21]; break
        case 16: surroundingTiles = [10, 11, 12, 15, 17, 20, 21, 22]; break
        case 17: surroundingTiles = [11, 12, 13, 16, 18, 21, 22, 23]; break
        case 18: surroundingTiles = [12, 13, 14, 17, 19, 22, 23, 24]; break
        case 19: surroundingTiles = [13, 14, 18, 23, 24]; break
        case 20: surroundingTiles = [15, 16, 21]; break
        case 21: surroundingTiles = [15, 16, 17, 20, 22]; break
        case 22: surroundingTiles = [16, 17, 18, 21, 23]; break
        case 23: surroundingTiles = [17, 18, 19, 22, 24]; break
        case 24: surroundingTiles = [18, 19, 23]; break
      }

      return surroundingTiles
    },

    findStringsToCheck (word, log) {
      const stringsToCheck = []

      // Define letter replacement function for wildcard
      function replaceAt (str, index, chr) {
        if (index > str.length - 1) return str
        return str.substring(0, index) + chr + str.substring(index + 1)
      }

      // Handle wildcard
      if (this.specialTile.code === '7') {
        stringsToCheck.push(word)
        for (var i = 0; i < [...word].length; i++) {
          stringsToCheck.push(replaceAt(word, i, '7'))
        }
      } else { // Handle double letter
        const splitStr = word.split(this.specialTile.value)

        if (splitStr.length === 1) { // No instances of special char found in word
          stringsToCheck.push(word)
        } else if (splitStr.length === 2) { // 1 instance of special char found in word
          stringsToCheck.push(word)
          stringsToCheck.push(`${splitStr[0]}${this.specialTile.code}${splitStr[1]}`)
        } else if (splitStr.length === 3) { // 2 instances of special char found in word
          stringsToCheck.push(word)
          stringsToCheck.push(`${splitStr[0]}${this.specialTile.code}${splitStr[1]}${this.specialTile.value}${splitStr[2]}`)
          stringsToCheck.push(`${splitStr[0]}${this.specialTile.value}${splitStr[1]}${this.specialTile.code}${splitStr[2]}`)
        } else if (splitStr.length === 4) { // 3 instances of special char found in word
          stringsToCheck.push(word)
          stringsToCheck.push(`${splitStr[0]}${this.specialTile.code}${splitStr[1]}${this.specialTile.value}${splitStr[2]}${this.specialTile.value}${splitStr[3]}`)
          stringsToCheck.push(`${splitStr[0]}${this.specialTile.value}${splitStr[1]}${this.specialTile.code}${splitStr[2]}${this.specialTile.value}${splitStr[3]}`)
          stringsToCheck.push(`${splitStr[0]}${this.specialTile.value}${splitStr[1]}${this.specialTile.value}${splitStr[2]}${this.specialTile.code}${splitStr[3]}`)
        }
      }

      if (log) { console.log(`Checking ${stringsToCheck}`) }

      return stringsToCheck
    },

    highlightLettersOnBoard (evt) {
      const log = false
      this.highlightedTiles = new Set() // Reset set
      this.$emit('change', evt)

      const value = this.sanitizeInput()
      // Sanitize input on desktop, leave input alone on mobile so autocorrect can still happen
      if (!this.compressedLayout) {
        this.$refs.wordInput.value = value
      }

      const validPaths = []

      // Check for words if input isnt empty
      if (value !== '') {
        // Find strings to check including replacements of the double letter
        const stringsToCheck = this.findStringsToCheck(value, log)
        console.log(stringsToCheck)

        // Loop through all of the found strings
        stringsToCheck.forEach(word => {
          const attempts = []
          const targetWord = word

          class Attempt {
            constructor (word, path) {
              this.letterArray = [...targetWord]
              this.path = path
              this.eligibleTiles = []
            }
          }

          // Find positions on the board where the first letter exists
          const startPositions = []
          this.rawBoardLetters.forEach((letter, i) => {
            if (letter === [...targetWord][0]) {
              if (log) { console.log(`${letter} found at position ${i}`) }
              startPositions.push(i)
            }
          })

          // Create new attempts from start position
          if (startPositions.length > 0) { // First letter exists on board
            startPositions.forEach(pos => {
              attempts.push(new Attempt(targetWord, [pos]))
            })
          }

          // Start looping through all attempts

          for (var i = 0; i < attempts.length; i++) {
            if (log) { console.log(`///// Attempt #${i} /////`) }
            if (log) { console.log(attempts[i].path) }

            // Check last item in this attempt's path
            const currentTile = attempts[i].path[attempts[i].path.length - 1]
            // const currentLetter = attempts[i].letterArray[attempts[i].path.length - 1]
            const letterToSearchFor = attempts[i].letterArray[attempts[i].path.length]
            const currentEligibleTiles = new Set(this.getSurroundingTiles(currentTile)) // // Determine eligible tiles based on current letter
            let tempPath = []

            // Remove letters used in this path
            attempts[i].path.forEach(usedTile => {
              currentEligibleTiles.delete(usedTile)
            })

            // Loop through eligible tiles to look for next letter in word
            currentEligibleTiles.forEach(tileNumber => {
              if (log) { console.log(`searching for ${letterToSearchFor} at ${tileNumber} (${this.rawBoardLetters[tileNumber]})`) }
              if (letterToSearchFor === this.rawBoardLetters[tileNumber]) { // Letter matches at this tile #
                tempPath = [...attempts[i].path] // Set a new temp path with that matches path so far on thsi attempt
                tempPath.push(tileNumber) // Add found letter tile to new path
                if (log) { console.log(`Match found, new path is ${tempPath}`) }
                attempts.push(new Attempt(targetWord, tempPath)) // Create a new attempt from this
              }
            })

            if (attempts[i].path.length === targetWord.length) {
              if (log) { console.log('Completed word found on board') }
              validPaths.push(attempts[i].path)
            }
          }

          if (log) { console.log('End of loop reached without finding the word') }
        })

        if (log) { console.log(validPaths) }

        // Designate tiles to update
        validPaths.forEach(path => {
          path.forEach(tile => {
            this.highlightedTiles.add(tile)
          })
        })

        console.log(this.highlightedTiles)
      }
    },

    openInstructions () {
      this.$modal.show('instructions')
    },

    openAbout () {
      this.$modal.show('about')
    },

    loadLocalStorage () {
      if (localStorage.userData) { // User has played before
        this.userData = JSON.parse(localStorage.userData)
        this.phase = parseInt(localStorage.phase)
        setTimeout(() => {
          if (this.startBtnHidden) {
            this.$modal.show('warning')
          }
        }, 500)
      } else { // First time user
        localStorage.userData = this.userData
        this.phase = 1
        localStorage.phase = 1
        setTimeout(() => {
          this.openInstructions()
        }, 500)
      }

      if (this.phase === 3) {
        this.hideLetters = false
      } else {
        this.hideLetters = true
      }
    },

    sanitizeInput () {
      let inputString = this.$refs.wordInput.value.replace(/\s/g, '') // Remove spaces
      inputString = inputString.replace(/[0-9]/g, '') // Remove numbers
      inputString = inputString.toLowerCase() // Convert to lowercase
      return inputString
    }

  },
  beforeMount () {
    console.log("Loading today's board")

    fetch('https://worldtimeapi.org/api/timezone/America/New_York').then((response) => {
      if (response.ok) {
        return response.json()
      } else {
        throw new Error('Something went wrong')
      }
    })
      .then((responseJson) => { // Day successfully fetched
        console.log(responseJson)

        this.dailyBoardData.forEach(board => {
          if (board.day === responseJson.day_of_year) { // Find matching day
            this.date = responseJson.datetime
            this.todaysBoard = board
            this.handleBoardLoad()

            let splitDate = this.date.split('T')
            splitDate = splitDate[1].split('.')
            splitDate = splitDate[0].split(':')
            const hours = splitDate[0]
            const minutes = splitDate[1]
            const seconds = splitDate[2]
            console.log(`${hours} hours ${minutes} minutes ${seconds} seconds`)
            const msTotal = 1 * 24 * 60 * 60 * 1000
            const msElapsed = (hours * 60 * 60 * 1000) + (minutes * 60 * 1000) + (seconds * 1000)
            console.log(msTotal)
            console.log(msElapsed)
            this.msLeft = msTotal - msElapsed + 500

            this.startBtnHidden = false
            this.$modal.hide('warning')
          }
        })
      })
      .catch((error) => { // Day fetch failed
        console.log(error)

        const dayOfYear = date => Math.floor((date - new Date(date.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24)
        const backupDay = dayOfYear(new Date())
        console.log(backupDay)

        this.date = new Date()
        this.dailyBoardData.forEach(board => {
          if (board.day === backupDay) { // Find matching day
            this.todaysBoard = board
            this.handleBoardLoad()
          }
        })

        console.log(this.date)

        const hours = this.date.getHours()
        const minutes = this.date.getMinutes()
        const seconds = this.date.getSeconds()
        console.log(`${hours} hours ${minutes} minutes ${seconds} seconds`)
        const msTotal = 1 * 24 * 60 * 60 * 1000
        const msElapsed = (hours * 60 * 60 * 1000) + (minutes * 60 * 1000) + (seconds * 1000)
        console.log(msTotal)
        console.log(msElapsed)
        this.msLeft = msTotal - msElapsed + 500

        this.startBtnHidden = false
        this.$modal.hide('warning')
      })
  },
  mounted () {
    const self = this

    console.log(isMobileOnly)
    this.isMobile = isMobile

    tinykeys(window, {
      Enter: () => {
        const inputString = this.sanitizeInput()
        self.handleSubmittedWord(inputString) // Handle submission
        this.$refs.wordInput.value = '' // Clear
      }
    })

    this.loadLocalStorage()

    window.addEventListener('resize', () => {
      this.windowSize = window.innerHeight
    })
  }
}
</script>

<style lang="scss">

.tooltip {
  z-index: 99999999;
  display: block;
  background: $slate700;
  color: $white;
  padding: 8px;
  border-radius: $radius;
  font-size: 13px;
  margin-bottom: 6px;
}

.submitted-words-enter-active, .submitted-words-leave-active {
  transition: all ease-out 100ms;
}
.submitted-words-enter, .submitted-words-leave-to  {
  opacity: 0;
}

h1, h2, p {
  margin: 0;
}

.hidden { display: none; }
.hiddenMax {display: none !important;}

#game {
  display: flex;
  justify-content: center;
  flex-direction: column;

  &.subdueColors {
    #headerSection, #mainSection {
      .primary, .secondary {background: $slate500 !important;}
      svg path, svg circle {stroke: $slate500 !important; fill: $slate500 !important;}
      .submittedWord .word {background: $slate500 !important; border-color: $slate500 !important;}
      img {filter: grayscale(1)}
    }
  }
}

.vm--container {

  .vm--overlay {
    background: rgb(0 0 0 / 75%);
    cursor: pointer;
    backdrop-filter: blur(5px);
    height: 120vh;

    // &:before {
    //   display: block;
    //   content: ' ';
    //   background-image: url('/img/close.svg');
    //   background-size: 28px 28px;
    //   height: 28px;
    //   width: 28px;

    //   z-index: 999999;
    //   position: absolute;
    //   top: 12px;
    //   right: 12px;
    // }
  }

  .vm--modal {
    background: $slate800;
    box-sizing: border-box;
    border-radius: $radius;
    overflow: visible;
    margin-bottom: 36px;
  }
}

.vm--modal, .modalContent, .modalContent .inner {
  &::-webkit-scrollbar {
    display: none;
  }
}

.modalContent {

  .inner {
    overflow-y: scroll;
    padding: 20px;
  }

  .closeButton {
    display: block;
    background-image: url('/img/close.svg');
    background-size: 28px 28px;
    height: 28px;
    width: 28px;
    cursor: pointer;
    transition: $transition;

    z-index: 999999;
    position: absolute;
    top: -10px;
    right: -10px;

    &:hover {
      transform: scale(1.2);
    }
  }

  .gold {color: $yellow300;}
  .green {color: $emerald400;}
  .blue {color: $blue400;}
  .purple {color: $violet400;}

  hr {
    border: 1px solid $slate700;
    margin: 18px 0;
  }

  .rowHeader {
    display: flex;
    justify-content: space-between;
    color: $white;
    font-weight: 500;
    margin-bottom: 16px;

    h3, h4{
      font-weight: 500;
      margin: 0;
    }

    h3 {font-size: 16px;}
    h4 {font-size: 13px;}
  }
}

#resultsModal {
  font-size: 14px;

  #modalLogo {
    svg {
      width: auto;
      height: 62px;
    }
  }

  #modalInfoRow {
    align-items: center;
    margin-top: 12px;

    .button {
      font-size: 14px;
      white-space: pre;
      padding: 8px;
    }

  }

  #modalTotalWords {

    #simplifiedWords {
      text-align: left;
    }

    .simplifiedWord {
      margin: 0 8px 8px 0;
    }
  }

  #modalWordBreakdown {

    .wordGroup {
      margin-top: 20px;
      &:first-of-type {margin-top: 0;}
    }

    #wordBars {
      display: flex;
      margin-bottom: 8px;

      .wordBar {
        display: flex;
        height: 25px;
        border: 2px solid $slate800;

        &.easy {background: $easy; border-radius: 4px 0 0 4px;}
        &.hard {background: $hard;}
        &.impossible {background: $impossible; border-radius: 0 4px 4px 0;}
      }
    }

  }

  .modalBadges {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .modalBadgeRow {
      display: flex;
      gap: 8px;

      .badge {
        border-radius: 4px;
        background: $slate700;
        color: $white;
        padding: 4px 8px;
        font-weight: 400;
        font-size: 14px;
        flex-grow: 1;
      }
    }
  }
}

#instructionsModal {
  text-align: left;

  // .inner {
  //  max-height: 530px;
  // }

  .instructionGroup {

    svg {
      width: 75% !important;
    }

    .rowHeader {
      margin-bottom: 4px;
    }

    p {
      font-size: 13px;
      line-height: 20px;
      margin-bottom: 16px;
      color: $slate200;
    }
  }

  #closeInstructions {
    width: 50%;
    margin-bottom: 72px;
  }
}

#warningModal {
  h2, p {
    color: $white;
    text-align: left;
    margin-bottom: 12px;
  }

}

#aboutModal {

  hr {margin: 24px 0;}

  #aboutHeader {
    display: flex;
    justify-content: space-between;
  }
  #credits {
    p {
      color: $slate500;
      text-align: right;
      font-size: 13px;
    }
  }
  #buttonRow {
    margin-top: 20px;
    display: flex;
    gap: 8px;

    .button {
      padding: 8px 10px;
      flex-grow: 1;
      display: flex;
      background: $slate700;
      border-radius: $radius;
      align-items: center;
      font-size: 13px;
      font-weight: 800;
      text-decoration: none;
      color: $white;
      white-space: pre;
      transition: $transition;

      svg {
        margin-right: 4px;
      }

      &:hover {
        &.twitter {
          background: $blue100;
          color: $blue600;
          svg * {
            stroke: $blue600;
            fill: $blue600
          }
        }

        &.email {
          background: $yellow100;
          color: $yellow600;
          svg * {
            stroke: $yellow600;
            fill: $yellow600
          }
        }

        &.coffee {
          background: $emerald100;
          color: $emerald600;
          svg * {
            stroke: $emerald600;
            fill: $emerald600
          }
        }
      }
    }
  }

  #faqSection {
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .faq {

      h3, p {
        margin: 0;
      }

      h3 {
        margin: 0;
        color: $white;
        font-size: 16px;
      }

      p {
        margin: 6px 0 0 0;
        color: $slate200;
        font-size: 13px;
        line-height: 20px;
      }

      a {
        color: $white;
      }
    }

  }
  .buttonContainer {
    display: flex;
    align-items: flex-start;

    #closeAbout {
      width: 50%;
    }
  }

}

.infoRow {
  display: flex;
  justify-content: center;
  color: $slate300;
  align-items: center;

  .bold, a {color: $white; font-weight: 700;}
  .separator {color: $slate600; margin: 0 8px;}
}

#headerSection {
  margin-top: 48px;

  #logo {
    width: 300px;
    display: inline-block;
    cursor: pointer;

    svg {

      circle {
        transition: all 50ms ease-out;
      }
    }
  }

  #infoRow {
    margin-top: 18px;

    a {
      display: flex;
      cursor: pointer;
      text-decoration: none;
      transition: $transition;
      padding: 8px 0;

      &:hover {
        &.blue {color: $blue400}
        &.yellow {color: $yellow300}
        &.green {color: $emerald400}
      }

      svg {
        margin-right: 8px;
      }
    }

    p, a {
      user-select: none;
    }
  }

}

#mainSection {
  margin-top: 42px;
  display: flex;
  justify-content: center;

  #boardSection {
    #board {
      background: $slate700;
      padding: 12px;
      display: inline-block;
      border-radius: 12px;
      box-shadow: 2px 2px 4px rgb(0 0 0 / 20%), 6px 6px 6px rgb(0 0 0 / 6%), 24px 24px 34px rgb(0 0 0 / 24%);
      cursor: not-allowed;

      .row {
          display: flex;
      }
    }
  }

  #sidePanel {
    width: 320px;
    margin-left: 48px;

    .infoBadge {
      padding: 12px;
      display: flex;
      background: $slate700;
      border-radius: $radius;
      align-items: center;

      h1 {
        font-size: 32px;
        font-weight: 500;
        color: $white;
        margin-left: 6px;
        white-space: pre;
      }

      .reg {font-weight: 400;}

      svg {
        min-width: 24px;

        path {
          stroke: $slate500;
          stroke-width: 2;
        }
      }
    }

    #newBoardCountdown {
      flex-direction: column;

      .infoBadgeMain {
        display: flex;
        flex-direction: row;
        align-items: center;

        svg {
          margin-right: 2px;
        }

        h1 {
          white-space: unset;
          font-weight: 700;
          font-size: 28px;

          .grey {
            color: $slate400;
          }
        }
      }

      h2 {
        color: $slate200;
        font-size: 14px;
        font-weight: 500;
      }

    }

    #gameInfo {
      display: flex;
      margin-top: 20px;

      #timerSection {
        min-width: 120px;
        // transition: all 1000ms ease-out;

        &.flashTimer {
          animation: timerFlash 1000ms infinite alternate;
          h1 {color: $amber800}
          svg path {stroke: $amber700}

          @keyframes timerFlash {
            0% {
              background: $amber400;
            }

            100% {
              background: $amber200;
            }
          }
        }
      }

      #scoreSection {
        margin-left: 12px;
        flex-grow: 1;
      }

    }

    #inputSection {

      #comboInput {position: relative;}

      #psuedoButton {
        position: absolute;
        top: 0;
        left: 0px;
        pointer-events: none;
      }

      #wordInput, button {
        width: 100%;
        height: 48px;
        font-size: 20px;
        font-weight: 700;
        border-radius: 8px;
        text-align: center;
      }

      button {
        text-shadow: 2px 2px 6px #0000004d;
      }

      .inputMode {
        background: $slate200;
        border: 2px solid $slate700;
        border-radius: 8px;
        outline: none;
        text-align: center;
        color: $slate700;
        transition: $transition;
      }

      .buttonMode {
        border: none;
        cursor: pointer;
        outline: none;
        background: $emerald500;
        &::placeholder {color: $white;}
        &:hover {background: $emerald600;}
      }

      #wordInput {

        &:focus::placeholder {color: transparent;}

        &.blue {border-color: $blue500; background: $blue200;}
        &.purple {border-color: $violet500; background: $violet200;}
        &.green {border-color: $emerald500; background: $emerald200;}
        &.red { border-color: $red500; background: $red200;}
        &.yellow {
          border-color: $yellow500; background: $yellow200;
          &::placeholder {color: $yellow700 !important;}
        }
      }
    }

    #submittedWords {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      align-content: flex-start;
      width: 100%;
      padding: 12px 12px 12px 2px;
      box-sizing: border-box;
      border: 2px dashed $slate400;
      border-radius: 10px;
      flex-wrap: wrap;
      min-height: 100px;
      overflow-y: scroll;
      transition: $transition;

      .submittedWord {
        margin: 0 0 10px 8px;
        transition: $transition;
      }

    }

    #endRoundBtn {
      width: 100%;
      margin-top: 20px;
    }

  }
}

.shake-bottom {animation:shake-bottom 500ms cubic-bezier(.455,.03,.515,.955) both}
@keyframes shake-bottom {
  0%,
  100% {
    transform: rotate(0deg);
    transform-origin: 50% 100%;
  }
  10% {
    transform: rotate(1deg);
  }
  20%,
  40%,
  60% {
    transform: rotate(-2deg);
  }
  30%,
  50%,
  70% {
    transform: rotate(2deg);
  }
  80% {
    transform: rotate(-1deg);
  }
  90% {
    transform: rotate(1deg);
  }
}

.jello {animation:jello 500ms both}
@keyframes jello {
  0% {
    transform: scale3d(1, 1, 1);
  }
  30% {
    transform: scale3d(1.04, .96, 1);
  }
  40% {
    transform: scale3d(.96, 1.03, 1);
  }
  50% {
    transform: scale3d(1.02, 0.97, 1);
  }
  65% {
    transform: scale3d(0.98, 1.02, 1);
  }
  75% {
    transform: scale3d(1.01, 0.98, 1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}

.vibrate{animation:vibrate 400ms ease-out both}
@keyframes vibrate {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translate(-2px, 2px);
  }
  40% {
    transform: translate(-2px, -2px);
  }
  60% {
    transform: translate(2px, 2px);
  }
  80% {
    transform: translate(2px, -2px);
  }
  100% {
    transform: translate(0);
  }
}

.wobble-hor-bottom{animation:wobble-hor-bottom 650ms ease-in-out both}
@keyframes wobble-hor-bottom {
  0%,
  100% {
    transform: translateX(0%);
    transform-origin: 50% 50%;
  }
  15% {
    transform: translateX(-20px) rotate(-3deg);
  }
  30% {
    transform: translateX(8px) rotate(3deg);
  }
  45% {
    transform: translateX(-8px) rotate(-1.8deg);
  }
  60% {
    transform: translateX(5px) rotate(1.2deg);
  }
  75% {
    transform: translateX(-3px) rotate(-.6deg);
  }
}

.bglAdSection {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  // display: none !important;

  .ad {
    display: block;
    background: $slate700;
  }
}

// Large
@media (min-width: 780px) {
  .hideOnLarge {display: none;}

  .vm--container.scrollable .vm--modal  {
    margin: 24px 0 48px 0 !important;
  }

  // #game {

  // }

  #desktopAdSection {
    margin-top: 48px;
    margin-bottom: 64px;

    .ad {
      width: 728px;
      height: 90px;
    }
  }
}

// Small
@media (max-width: 779px) {

  .hideOnSmall {display: none;}

  #mobileAdSection {
    margin-top: 20px;

    .ad {
      width: 320px;
      height: 50px;
    }
  }

  .vm--container.scrollable .vm--modal  {
    margin: 12px 0 36px 0 !important;
  }

  #game {
    margin-bottom: 36px;
  }

  #headerSection {
    margin-top: 24px;

    .mobileDate {
      color: $white;
      font-size: 13px;
    }

    #logo {
      margin-top: 12px;
      width: 240px;
    }

    #infoRow {
      font-size: 13px;
      margin-top: 4px;
    }
  }

  #mainSection {
    flex-direction: column;
    align-items: center;
    margin-top: 24px;

    #boardSection {
      width: 325px;
      height: 325px;

    }

    #sidePanel {
      margin: 18px 0 0 0;

      #gameInfo, #submittedWords {
        margin-top: 18px
      }

      .infoBadge {
        justify-content: center;
        height: 46px;

        h1 {
          font-size: 24px;
        }
      }

      #newBoardCountdown {
        height: 70px;

        .infoBadgeMain {

          h1 {
            font-size: 24px;
          }

          svg {
            margin-right: 0;
            min-width: 22px;
            width: 22px;
            height: 22px;
          }
        }
      }

      #gameInfo {

      }

      #inputSection {

        #wordInput, button {
          height: 42px;
          font-size: 16px;
        }

        #wordInput {

        }

      }

    }
  }

  .compressedLayout {

    #compressedLogo {
      z-index: 99999999;
      width: 120px;
      position: absolute;
      top: 16px;
      left: 18px;
    }

    #headerSection {
      display: none;
    }

    $sectionSize: 228px;

    #mainSection {
      margin-top: 52px;
      margin-left: 10px;
      width: $sectionSize;
      align-items: flex-start;

      #boardSection {
        width: $sectionSize;
        height: $sectionSize;

        #board {
          padding: 4px;
          box-shadow: none;
          border-radius: 5px;
        }
      }

      #sidePanel {
        width: 100%;
        margin-top: 12px;

        button, .infoBadge {
          font-size: 13px;
          height: 28px;
          border-radius: 4px;
          padding: 0 14px;
        }

        #newBoardCountdown {
          display: none;
        }

        .infoBadge {
          padding: 8px 8px;

          h1 {
            font-size: 13px;
            font-weight: 700;
          }

          svg {
            width: 12px;
            height: 12px;
            min-width: 12px;
          }

        }

        #gameInfo {
          position: absolute;
          margin: 0;
          top: 16px;
          right: 16px;

          .button {
            border-width: 1px;
          }

          #endRoundBtnCompressed {

          }

          #scoreSection {
            margin-left: 6px;
          }

          #timerSection {
            margin-left: 6px;
            min-width: 66px;
          }

        }

        #inputSection {

          #wordInput, button {
            height: 36px;
            font-size: 16px;
          }

          #wordInput {
            &::placeholder {
              font-size: 13px;
            }
          }
        }

        #submittedWords {
          position: absolute;
          top: 42px;
          left: 260px;
          width: calc( 100% - 274px );
          height: 276px;
          border-radius: 5px;
          border-width: 1px;
          min-height: unset;
          max-height: unset;

          .word {
            border-radius: 4px;
            font-weight: 500;
            font-size: 13px;
            padding: 4px;
          }
        }

      }
    }

  }

}

</style>
